import { Injectable } from "@angular/core";
import { RelationshipVm } from "app/_mapper/relationship.vm";
import { CaseModel } from "app/_models";
import { CallBackModel } from "app/_models/call-back.model";
import { CaseType } from "app/_models/case-type/add-edit-case-type.model";
import { ConcernedPersonModel } from "app/_models/concernedPerson.model";
import { ContactPerson } from "app/_models/contact-person.model";
import { CoronerModel } from "app/_models/coroner.model";
import { Country } from "app/_models/country.model";
import { DeadPersonModel } from "app/_models/deadPerson.model";
import { DeathDetailModel } from "app/_models/death-detail.model";
import { DiagnoseModel } from "app/_models/diagnose.model";
import { FellowTraveller } from "app/_models/fellow-traveller.model";
import { GeneralModel } from "app/_models/general.model";
import { HealthInsurance } from "app/_models/health-insurance.model";
import { HelpPlanTypeModel } from "app/_models/help-plan-type.model";
import { HelpPlanDetailsModel } from "app/_models/helpPlanDetails.model";
import { Insuree } from "app/_models/insuree.model";
import { IntakeHelpPlansModel } from "app/_models/intake-help-plans.model";
import { IntakeModel, intakeStepsData } from "app/_models/intake.model";
import { IntakeDataModel } from "app/_models/intakedata.model";
import { intakeTimeValueModel } from "app/_models/intakeTimeValue.model";
import { LocationType } from "app/_models/location-type.model";
import { LocationDetailsModel } from "app/_models/location_details.model";
import { PersonalInformation } from "app/_models/personal-information.model";
import { PolicyControl } from "app/_models/policycontrol.model";
import { Relationship } from "app/_models/relationship.model";
import { SummaryDetailsModel } from "app/_models/summary-details.model";
import { TravelDetailModel } from "app/_models/travel-detail.model";
import { TravelInsurance } from "app/_models/travel-insurance.model";
import { TravelLegModel } from "app/_models/travel-leg.model";
import { IntakeService } from "./intake-services/intake.service";
import { NoInsurancePolicyModel } from "./policy/models/no-insurance-policy.model";
import { RehospitalisationModel } from "./rehospitalisation/models/rehospitalisation.model";
import { AuthenticationService, SharedService } from "app/_services";
import { AdlModel } from "./adl/models/adl.model";
import { InvolvedPartyRelationType } from "./party/involvedPartyRelationType";
import { PieceLayoutModel } from "app/piece-layout/models/piece-layout.model";
import { SosClientsProductsCoverageDetailsComponent } from "app/support/sosClients/sos-clients-products-coverage-details/sos-clients-products-coverage-details.component";
import { DateService } from "app/_services/date.service";
import { STATUS_POLICY_CHECK_DATA } from "./policy-module/travel-Insurances/travel-insurance-enums/travel-insurance-status-policy-check-data";
import { PersonalInfo } from "app/_models/PersonalInfo.model";
@Injectable({
  providedIn: "root",
})
export class IntakeMapperService {
    constructor(
    private intakeService: IntakeService,
    private authenticationService: AuthenticationService,
    private dateService :DateService,
    private sharedService: SharedService
  ) {}

  dataFromApi(dossier): IntakeModel {
    let _intake = new IntakeModel();
    let _policy = new PolicyControl();
    _policy.dossierNbr = dossier.dossierNumber;
    _intake.intake.dossierId = dossier.dossierId;
    _intake.intake.assignmentId = dossier.assignmentId;
    _intake.intake.creationDate = dossier.creationDate;
    _intake.intake.userEmail = dossier.userEmail;
    _intake.intake.intakeDuration = dossier.intakeDuration;
    _intake.intake.dossierStatus = dossier.dossierStatus;
    _intake.intake.isUrgent = dossier.isUrgent;
    _intake.intakeDuration = new intakeTimeValueModel();
    _intake.intakeDuration.duration = dossier.intakeDuration;
    _intake.intake.summary = new SummaryDetailsModel();
    _intake.intake.summary.agreement = dossier.agreements;
    _intake.intake.summary.comment = dossier.comments;
    _intake.intake.summary.coverage = dossier.coverage;
    _intake.intake.policy = new PolicyControl();
    _intake.intake.policy.dossierNbr = dossier.dossierNumber;
    _intake.intake.policy.country = new Country();
    _intake.intake.policy.country.id = dossier.policy.countryId;
    let _personalInfo = new PersonalInfo();
    _personalInfo = dossier.policy.personalInformations ? dossier.policy.personalInformations : _personalInfo;
    _policy.personalInformations = _personalInfo;    
    _policy.client.id = dossier.policy.clientId;
    _policy.client.shortName = dossier.policy.clientName;
    _policy.client.code = dossier.policy.clientCode;
    _policy.country = dossier.policy.country
    _policy.isNoPolicycheck = dossier.policy.isOwnCost;
    _policy.selectedCalamities = dossier.policy.calamityId;
    _policy.location = dossier.policy.accidentLocation;    
    _policy.iagCorePartner.id = dossier.policy.iagPartnerId;
    _policy.nedherlandAla.id = dossier.policy.nedherlandAlaId;
    _policy.reason = dossier.policy.reason;
    _policy.iagPartnerCaseNumber = dossier.policy.iagPartnerCaseNumber;
    _policy.incidentDate = dossier.policy.incidentDate;
    //for now
    _policy.selectedtravelPolicies = [];
    dossier.policy.travelInsurancePolicies.forEach(tip => {
      let travelInsurance = new TravelInsurance();
      travelInsurance.id = tip.id;
      travelInsurance.ptiAlarmcenter = tip.alarmcenter;
      travelInsurance.arrangedBy = tip.arrangedBy;
      travelInsurance.ptiComment = tip.comment;
      travelInsurance.expiryDate = tip.expiryDate;
      travelInsurance.ptiBeginTravelDate = tip.beginTravelDate;
      travelInsurance.ptiReturnDate = tip.returnDate;      
      travelInsurance.familyComposition = tip.familySituation;
      travelInsurance.coverageArea = tip.coverageArea;
      travelInsurance.initials = tip.initials;
      travelInsurance.ptiInsurer = {id :tip.insurerId, shortName: tip.insurerShortName};
      travelInsurance.insurerNumber = tip.insurerNumber;
      travelInsurance.ptiInsurerPhoneNumber = tip.insurerPhoneNumber;
      travelInsurance.ptiIntermediary = tip.intermediary;
      travelInsurance.ptiReferenceDate = tip.referenceDate;
      travelInsurance.ptiIntermediaryPhoneNumber = tip.intermediaryPhoneNumber;
      travelInsurance.ptiIsManual = tip.isManual;
      travelInsurance.lastName = tip.lastName;
      travelInsurance.ptiMandate = {id :tip.mandate, shortName: tip.mandateShortName};
      travelInsurance.mandateNumber = tip.mandateId;
      travelInsurance.ptiMandatePhoneNumber = tip.mandatePhoneNumber;
      travelInsurance.policyHolderCity = tip.policyHolderCity;
      travelInsurance.policyHolderCountryCode = tip.policyHolderCountryCode;
      travelInsurance.policyHolderHouseNumber = tip.policyHolderHouseNumber;
      travelInsurance.policyHolderHouseNumberAddOn = tip.policyHolderHouseNumberAddOn;
      travelInsurance.policyHolderLastName = tip.policyHolderLastName;
      travelInsurance.policyHolderStreet = tip.policyHolderStreet;
      travelInsurance.policyHolderZipCode = tip.policyHolderZipCode;
      travelInsurance.policyNumber = tip.policyNumber;
      travelInsurance.policyOverview = tip.policyOverview;
      travelInsurance.productCode = tip.productCode;
      travelInsurance.policyCommencementDate = tip.policyCommencementDate;
      travelInsurance.otherAlarmcenter = tip.otherAlarmcenter;
      travelInsurance.policyCheckDate = tip.policyCheckDate;
      travelInsurance.personName = tip.personName;
      travelInsurance.product ={productId:tip.productId,productName: tip.productName,productCode:tip.productCode};
      travelInsurance.productType = tip.productType;
      travelInsurance.productId = tip.productId;
      travelInsurance.ptiStatusPolicyCheck =STATUS_POLICY_CHECK_DATA.find(s=>s.id == tip.statusPolicyCheck);
      travelInsurance.ptiTravelAgency = tip.travelAgency;
      travelInsurance.ptiTravelAgencyPhoneNumber = tip.travelAgencyPhoneNumber;
      travelInsurance.ptiTypePolicyCheck = tip.typePolicyCheck;
      travelInsurance.medicalcosts = tip.medicalcosts;
      travelInsurance.policyHolderLastName = tip.policyHolderLastName;
      travelInsurance.skiing = tip.skiing;
      travelInsurance.crosscountryskiing = tip.crosscountryskiing;
      travelInsurance.worldcoverage = tip.worldcoverage;
      travelInsurance.europeancoverage = tip.europeancoverage;
      travelInsurance.specialsports = tip.specialsports;
      travelInsurance.other = tip.other;
      travelInsurance.carassistance = tip.carassistance;
      travelInsurance.ptiClient={ id :tip.clientId};
      travelInsurance.ptiMAlarmcenter={ id :tip.alarmCenterId};
      travelInsurance.ptiChargedExpenses={ id :tip.chargedExpensesId};
      travelInsurance.ptiServiceFees={ id :tip.feeServiceId};
      travelInsurance.assignmentId = tip.assignmentId ? tip.assignmentId:dossier.assignmentId;
      travelInsurance.policyDetails=tip.policyDetails;
      travelInsurance.involvedPartyId = tip.involvedPartyId ? tip.involvedPartyId:null;
      travelInsurance.involvedParty = tip.involvedParty ? tip.involvedParty:null;
      travelInsurance.insurerId = tip.insurerId;
      travelInsurance.productName ={productId:tip.productId,productName: tip.productName};
      travelInsurance.coveredPerson = tip.coveredPerson;
      _policy.selectedtravelPolicies.push(travelInsurance);
    });
    _policy.selectedhealthPolicies = [];
    dossier.policy.healthInsurancePolicies.forEach(hip => {
      let healthInsurance = new HealthInsurance();
      healthInsurance.id = hip.id;
      healthInsurance.dossierId = hip.dossierId;
      healthInsurance.vhiInsurerPhonenumber = hip.insurerPhoneNumber;
      healthInsurance.vhiHealthInsuranceNumber = hip.healthInsuranceNumber;
      healthInsurance.vhiDateofBirth = dossier.insuree.dateOfBirth;
      healthInsurance.vhiStatusPolisCheck = hip.statusPolicyCheck;
      healthInsurance.vhiTypePolicyCheck = hip.typePolicyCheck;
      healthInsurance.vhiReferenceDate = hip.referenceDate;
      healthInsurance.vhiInsurer = {}
      healthInsurance.vhiInsurer.shortName = healthInsurance.vhiInsurer ? hip.insurer : null;
      healthInsurance.vhiInsurer.id = healthInsurance.vhiInsurer ? hip.insurerId : null;
      //healthInsurance.vhiInsurer.parentOuId = healthInsurance.vhiInsurer ? hip.insurer : null;
      healthInsurance.vhiAlarmcenter = hip.alarmcenter;
      healthInsurance.vhiComments = hip.comment;
      healthInsurance.vhiIsManual = hip.isManual;
      healthInsurance.vhiBsn = hip.bsn;
      healthInsurance.vhiPolicyType = hip.policyType;
      healthInsurance.vhiProductType = hip.productType;
      healthInsurance.vhiPolicyName = hip.policyName;
      healthInsurance.vhiPolicyCode = hip.policyCode;
      healthInsurance.vhiProductId = hip.productId;
      healthInsurance.vhiInsuranceCoverageId = hip.insuranceCoverageId;
      healthInsurance.vhiPersonName = hip.personName;
      healthInsurance.vhiUzovi = hip.uzovi;
      healthInsurance.vhiOtherAlarmCenter = hip.otherAlarmcenter;
      healthInsurance.vhiDatePolicyCheck = hip.datePolicyCheck;
      healthInsurance.vhiClient=hip.clientId;
      healthInsurance.vhiMAlarmcenter=hip.alarmCenterId;
      healthInsurance.vhiChargedExpenses=hip.chargedExpensesId;
      healthInsurance.vhiServiceFees=hip.feeServiceId;
      healthInsurance.assignmentId = hip.assignmentId?hip.assignmentId:dossier.assignmentId;
      healthInsurance.vhiStartDate = hip.startDate;
      healthInsurance.vhiEndDate = hip.endDate;
      _policy.selectedhealthPolicies.push(healthInsurance);

    });
    _policy.noInsurancePolicies = [];
    if(dossier.policy.noInsurancePolicies != undefined){
      dossier.policy.noInsurancePolicies.forEach(nip => {
        let noInsurancePolicy = new NoInsurancePolicyModel();
        noInsurancePolicy.nipId = nip.nipId;
        noInsurancePolicy.nipAssociatedOuId = {}
        noInsurancePolicy.nipAssociatedOuId.id = noInsurancePolicy.nipAssociatedOuId ? nip.nipAssociatedOuId : null;
        noInsurancePolicy.nipIagPartnerCaseNumber = nip.nipIagPartnerCaseNumber;
        noInsurancePolicy.nipCoverageType = nip.nipCoverageType;
        noInsurancePolicy.nipPolicyCheckStatus = nip.nipPolicyCheckStatus;
        noInsurancePolicy.nipDossierId = nip.nipDossierId;
        _policy.noInsurancePolicies.push(noInsurancePolicy);
      });
    }

    _intake.intake.policy = _policy;
    
    _intake.intake.policy.causes = this.populateCauses(dossier);
    _policy.cause = _intake.intake.policy.causes[0];    

    _intake.intake.cases = this.populateCaseDetails(dossier);
    _intake.intake.case = this.populateCaseDetail(dossier.caseDetail);

    //---------
    //Insuree
    let _insuree = new Insuree();
      _insuree.ipaId = dossier.insuree.id;
      _insuree.ipaBsnCitizenServiceNumber = dossier.insuree.bsn;
      _insuree.ipaInitials = dossier.insuree.initials;
      _insuree.ipaFirstName = dossier.insuree.firstName;
      _insuree.ipaLastName = dossier.insuree.lastName;
      _insuree.ipaMaidenName = dossier.insuree.maidenName;
      _insuree.ipaStreetName = dossier.insuree.streetName;
      _insuree.ipaHouseNumber = dossier.insuree.houseNumber;
      _insuree.ipaHouseNumberAddition = dossier.insuree.houseNumberAddition;
      _insuree.ipaPostalCode = dossier.insuree.postalCode;
      _insuree.ipaCity = dossier.insuree.city;
      _insuree.country = new Country();
      _insuree.country.id = dossier.insuree.countryId;
      _insuree.ipaPhoneNumber = dossier.insuree.phoneNumber;
      _insuree.ipaPhoneNumber2 = dossier.insuree.phoneNumber2;
      _insuree.ipaEmail = dossier.insuree.email;
      _insuree.ipaDateOfBirth = dossier.insuree.dateOfBirth;
      _insuree.ipaPartyGender = dossier.insuree.gender;
      _insuree.ipaRemarks = dossier.insuree.remarks;
      _insuree.ipaContactInitiation = dossier.insuree.contactInitiationId;
      _insuree.ipaContactWith = dossier.insuree.contactWithId;
      _insuree.ipaContactTelephone = dossier.insuree.contactInitiationPhone;
      _insuree.ipaContactEmail = dossier.insuree.contactEmail;
      _insuree.ipaContactComment = dossier.insuree.contactComment;
      _insuree.ipaSharePrivateInformation = dossier.insuree.sharePrivateInformation;
      _insuree.ContactPersons = [];
      _insuree.TravelInsurances = dossier.insuree.travelInsurances;
      dossier.insuree.contactPersons.forEach(cp => {
        let contactPerson = new ContactPerson();
        contactPerson.cpeFirstName = cp.firstName;
        contactPerson.cpeLastName = cp.lastName;
        contactPerson.cpeMaidenName = cp.maidenName;
        contactPerson.cpeGender = cp.genderId;
        contactPerson.cpePhoneNumber = cp.phoneNumber;
        contactPerson.cpeEmail = cp.email;
        contactPerson.cpeRelationship = new Relationship();
        contactPerson.cpeRelationship.prId = cp.relationship.pr_Id;
        contactPerson.cpeRelationship.prName = cp.relationship.pr_Name;
        contactPerson.cpeAddress = cp.address;
        contactPerson.cpeCity = cp.city;
        contactPerson.cpeCountry = new Country();  
        contactPerson.cpeCountry.id = cp.countryId;
        contactPerson.cpeRemarks = cp.remarks;
        contactPerson.cpeSharePrivateInformation = cp.sharePrivateInformation;
        _insuree.ContactPersons.push(contactPerson);
      }); 
    _intake.intake.insuree = _insuree;
    //travel
    _intake.intake.travels = this.populateTravels(dossier);
    _intake.intake.travel = _intake.intake.travels[0];
    
    //rehospitalisation
    let _rehospitalisation = new RehospitalisationModel();
    if (dossier.rehospitalisation != null) {
      _rehospitalisation.supplier = dossier.rehospitalisation.supplierId;
      _rehospitalisation.type = dossier.rehospitalisation.type;
      _rehospitalisation.admissionDate = this.getLocaleDate(dossier.rehospitalisation.admissionDate);
      _rehospitalisation.department = dossier.rehospitalisation.department;
      _rehospitalisation.reportAt = dossier.rehospitalisation.reportAt;
      _rehospitalisation.comment = dossier.rehospitalisation.comment;
      _rehospitalisation.consentingDoctor_ContactPersonName = dossier.rehospitalisation.consentingDoctorContactPersonName;
      _rehospitalisation.consentingDoctor_ContactPersonFunction = dossier.rehospitalisation.consentingDoctorContactPersonFunction;
      _rehospitalisation.consentingDoctor_ContactPersonPhoneNumber = dossier.rehospitalisation.consentingDoctorContactPersonPhoneNumber;
    }
    _intake.intake.rehospitalisation = _rehospitalisation;

        //adl
    let _adl = new AdlModel();
    if (dossier.adl != null) {
      _adl.length = dossier.adl.length;
      _adl.weight = dossier.adl.weight;
      _adl.adlMobility = dossier.adl.adlMobility;
      _adl.heartLungProblems = dossier.adl.heartLungProblems;
      _adl.repatriationQuestion = dossier.adl.repatriationQuestion;
      _adl.cast = dossier.adl.cast;
      _adl.covid = dossier.adl.covid;
      _adl.lastModifiedDate = dossier.adl.lastModifiedDate;
      _adl.lastModifiedBy= dossier.adl.lastModifiedBy;
      _adl.adlOtherActivities = dossier.adl.adlOtherActivities;
      _adl.homeSituation = dossier.adl.homeSituation; 
      _intake.intake.adl = _adl;
    }

    //Parties
    let _parties: FellowTraveller[] = [];
    dossier.parties.forEach(p => {
      let fellowTraveller = new FellowTraveller();
      fellowTraveller.fellowTravellerId = p.fellowTravellerId;
      fellowTraveller.ftdConcernedPersonType = {};
      fellowTraveller.ftdConcernedPersonType.rcId = p.concernedPersonType,
      fellowTraveller.ftdConcernedPersonType.rcLongName = p.concernedPersonTypeLabel,
      fellowTraveller.ftdFirstName = p.firstName;
      fellowTraveller.ftdLastName = p.lastName;
      if(fellowTraveller.ftdEscortType==null){
        fellowTraveller.ftdInvolvedPartyRelationType = new InvolvedPartyRelationType();
        fellowTraveller.ftdInvolvedPartyRelationType.iprtId = p.relationship;
        fellowTraveller.ftdInvolvedPartyRelationType.iprtName = p.relationshipName;
      }
      if(fellowTraveller.ftdEscortType==null){
        fellowTraveller.ftdRelationship = new Relationship()
        fellowTraveller.ftdRelationship.prId = p.relationship;
        fellowTraveller.ftdRelationship.prName = p.relationshipName;
      }
      fellowTraveller.ftdInitials = p.initials;
      fellowTraveller.ftdIMaidenName = p.middleName;
      fellowTraveller.ftdDateOfBirth = p.dateOfBirth;
      fellowTraveller.ftdPostalCode = p.postalCode;
      fellowTraveller.ftdHouseNumber = p.houseNumber;
      fellowTraveller.ftdHouseNumberAddition = p.houseNumberAddition;
      fellowTraveller.ftdStreetName = p.streetName;
      fellowTraveller.ftdCity = p.city;
      fellowTraveller.country = new Country();
      fellowTraveller.country.id = p.countryId;
      fellowTraveller.ftdPhoneNumber = p.phoneNumber;
      fellowTraveller.ftdPhoneNumber2 = p.phoneNumber2;
      fellowTraveller.ftdEmail = p.email;
      fellowTraveller.ftdEscortType = p.escortType
      fellowTraveller.ftdGender = parseInt(p.gender);
      fellowTraveller.ftdActive =  !p.inactive;
      fellowTraveller.ftdAssignmentId = p.assignmentId;
      fellowTraveller.ftdHasSameTravelInsurance = p.hasSameTravelInsurance;
      fellowTraveller.ftdHasTravelInsurance = p.travelInsurances.length>0 ?"Yes":"No" ;
      let travelinsuranceList: TravelInsurance[] = [];
      p.travelInsurances.forEach(t => {
        let travel = new TravelInsurance();
        travel.isSelected = true;
        travel.id = t.id;
        travel.ptiAlarmcenter = t.alarmcenter;
        travel.arrangedBy = t.arrangedBy;
        travel.ptiComment = t.comment;
        travel.expiryDate = t.expiryDate;
        travel.ptiBeginTravelDate = t.BeginTravelDate;
        travel.ptiReturnDate = t.ReturnDate;   
        travel.initials = t.initials;
        travel.insurer = t.insurerId;
        travel.insurerNumber = t.insurerNumber;
        travel.ptiInsurerPhoneNumber = t.insurerPhoneNumber;
        travel.ptiIntermediary = t.intermediary;
        travel.ptiReferenceDate= t.referenceDate;
        travel.ptiIntermediaryPhoneNumber = t.intermediaryPhoneNumber;
        travel.ptiIsManual = t.isManual;
        travel.ptiMandate = t.mandateId ? t.mandateId : t.mandate;
        travel.ptiMandatePhoneNumber = t.mandatePhoneNumber;
        travel.policyDetails = t.policyDetails;
        travel.policyHolderCity = t.policyHolderCity;
        travel.policyHolderCountryCode = t.policyHolderCountryCode;
        travel.policyHolderHouseNumber = t.policyHolderHouseNumber;
        travel.policyHolderHouseNumberAddOn = t.policyHolderHouseNumberAddOn;
        travel.policyHolderZipCode = t.policyHolderZipCode;
        travel.policyHolderStreet = t.policyHolderStreet;
        travel.policyHolderLastName = t.policyHolderLastName;
        travel.policyNumber = t.policyNumber;
        travel.policyOverview = t.policyOverview;
        travel.productCode = t.productCode;
        travel.policyCommencementDate = t.policyCommencementDate;
        travel.otherAlarmcenter= t.otherAlarmcenter;
        travel.coverageArea = t.coverageArea;
        travel.familyComposition = t.familySituation;
        travel.policyCheckDate = t.policyCheckDate;
        travel.personName = t.personName;
        travel.productType = t.productType;
        travel.productName ={productName: t.productName, productId: t.productId};
        travel.productId = t.productId;
        travel.ptiStatusPolicyCheck = t.statusPolicyCheck;
        travel.ptiTravelAgency = t.travelAgency;
        travel.ptiTravelAgencyPhoneNumber = t.travelAgencyPhoneNumber;
        travel.ptiTypePolicyCheck = t.typePolicyCheck;
        travel.medicalcosts = t.medicalcosts;
        travel.skiing = t.skiing;
        travel.crosscountryskiing = t.crosscountryskiing;
        travel.worldcoverage = t.worldcoverage;
        travel.europeancoverage = t.europeancoverage;
        travel.specialsports = t.specialsports;
        travel.other = t.other;
        travel.carassistance = t.carassistance;
        travel.ptiInvolvedPartyId = t.involvedPartyId;
        travel.ptiInvolvedParty = t.involvedParty;
        travelinsuranceList.push(travel);
      });
      fellowTraveller.ftdTravelInsurances =  travelinsuranceList;
      _parties.push(fellowTraveller);
    });

    _intake.intake.parties = _parties;
    //HelpPlan
    let helpPlans: HelpPlanDetailsModel[] = [];
    let i = 0;
    dossier.helpPlans.forEach(h => {
      let helpPlan = new HelpPlanDetailsModel();
      helpPlan.dhpCreatedDate = new Date(h.dhpCreatedDate);
      helpPlan.parentHelpPlanId = h.parentHelpPlanId;
      helpPlan.hpdId = h.dossierHelpPlanId;
      helpPlan.hpdCode = h.helpPlanCode.trim();
      helpPlan.dossierHelpPlanId = h.dossierHelpPlanId;
      helpPlan.hpdHelpPlanType = h.helpPlanTypeId;
      helpPlan.hpdHelpPlan = h.helpPlanId;
      helpPlan.workingOrder = h.workingOrder;
      helpPlan.selectedTravelLegId = h.selectedTravelLegId;
      helpPlan.concernedPersonList = [];
       h.concernedPersonHelpPlans.forEach(cp => {
         let concernedPerson = new ConcernedPersonModel();
        concernedPerson.dhpId = cp.dhpId;
         concernedPerson.ipaId = cp.ipaId;
         concernedPerson.chpId = cp.chpId;
         helpPlan.concernedPersonList.push(concernedPerson);
       });
      helpPlan.travelLegList = [];
       h.travelLegs.forEach(tl => {
        let travelLeg = new TravelLegModel();

        tl.tlDepartureDate = this.dateService.getFormatedDateFromAPI(tl.tlDepartureDate);
        tl.tlArrivalDate = this.dateService.getFormatedDateFromAPI(tl.tlArrivalDate);
        travelLeg = tl;
        helpPlan.travelLegList.push(travelLeg);
      });
      helpPlan.services = [];
      if(h.services){
        h.services.forEach(service => {
          helpPlan.services.push(service);
        });
      }
      helpPlan.proformaInvoiceList = [];
      if( h.workingOrderLines){
        h.workingOrderLines.forEach(pr => {
       let proformaInvoice = new PieceLayoutModel();
       proformaInvoice = pr;
       helpPlan.proformaInvoiceList.push(proformaInvoice);
        });
      }
      helpPlan.hdSpecific = {
        rmrRepatmortalremains: h.repatMortalRemains,
        rmrComment: h.rmrComment,
        tdComment: h.tdComment,
        tdTransferDepartureComment: h.tdTransferDepartureComment,
        tdTransferArrivalComment: h.tdTransferArrivalComment,
        tdisTranferDeparture: h.tdIsTransferDeparture,
        tdisTransferArrival: h.tdIsTransferArrival,
        tdisTravelneeded: h.tdIsTravelneeded,
        Request: {
          id: h.request,
        },
        hdBSN: h.hdBsn,
        hdComment: h.hdComment,
        hdDefinite: h.hdIsDefinite,
        hdDepartment: h.hdDepartment,
        hdHealthInsuranceAlarmcenter: h.hdHealthInsuranceAlarmcenter,
        hdIntensiveCare: h.hdIsIntensiveCare,
        hdIntensiveCareFromDate: this.dateService.getFormatedDateFromAPI(
          h.hdIntensiveCareFromDate
        ),
        hdIntensiveCareToDate: h.hdIntensiveCareToDate,
        hdRequestFromDate: this.dateService.getFormatedDateFromAPI(
          h.hdRequestFromDate
        ),
        hdRequestToDate: this.dateService.getFormatedDateFromAPI(
          h.hdRequestToDate
        ),
        hdRoomNumber: h.hdRoomNumber,
        hdTravelInsuranceAlarmcenter: h.hdTravelInsuranceAlarmcenter,
        hdisTransferArrival: h.hdisTransferArrival,
        hdisTransferDeparture: h.hdisTransferDeparture,

        otdBSN: h.otdBSN,
        otdComment: h.otdComment,
        otdDate: this.dateService.getFormatedDateFromAPI(h.otdDate),
        otdHealthInsuranceAlarmcenter: h.otdHealthInsuranceAlarmcenter,
        otdTravelInsuranceAlarmcenter: h.otdTravelInsuranceAlarmcenter,
        otdisTransferArrival: h.otdisTransferArrival,
        otdisTransferDeparture: h.otdisTransferDeparture,

        tadLinkedHelpPlan: h.tadLinkedHelpPlan
          ? h.tadLinkedHelpPlan
          : h.dhpLinkedHelpPlan,
        tadDateTime: this.dateService.getFormatedDateFromAPI(h.tadDateTime),
        tadFrom: h.tadFrom,
        tadTo: h.tadTo,
        tadTransportMode: h.tadTransportMode,

        tddLinkedHelpPlan: h.tddLinkedHelpPlan
          ? h.tddLinkedHelpPlan
          : h.dhpLinkedHelpPlan,
        tddDateTime: this.dateService.getFormatedDateFromAPI(h.tddDateTime),
        tddFrom: h.tddFrom,
        tddTo: h.tddTo,
        tddTransportMode: h.tddTransportMode,
        client: {
          value: h.dhpClient,
        },
        contractedSupplier: {
          value: h.dhpContractedSupplier,
        },
        otherSupplier: {
          value: h.dhpOtherSubContractorId,
        },
        paymentType: h.dhpPaymentType,
        product: h.dhpProduct,
        sosGuarantee_sosEhic: h.dhpSosGuarantee,
        status: { code: h.dhpStatus, shortName: h.dhpStatus },
        approvedGuaranteeByMedicalTeamUntil:
          h.dhpApprovedGuaranteeByMedicalUntil,
        luggage: h.dhpLuggage,
        repatMedicalUrgent: h.dhpIsRepatriationMedicalUrgent,
        transportationMode: h.dhpTrasportationMode,
        departureCountry: { iso3Code: h.dhpDepartureCountry },
        departureLocation: h.dhpDepartureLocation,
        departureAirport: { arpId: h.dhpDepartureAirport },
        departureDateTime:
          h.dhpDepartureDateTime != null &&
          new Date(h.dhpDepartureDateTime) instanceof Date
            ? this.dateService.getFormatedDateFromAPI(h.dhpDepartureDateTime)
            : null,
        arrivalLocation: h.dhpArrivalLocation,
        arrivalCountry: { iso3Code: h.dhpArrivalCountry },
        arrivalAirport: { arpId: h.dhpArrivalAirport },
        arrivalDateTime:
          h.dhpArrivalDateTime != null &&
          new Date(h.dhpArrivalDateTime) instanceof Date
            ? this.dateService.getLocaleDate(h.dhpArrivalDateTime)
            : null,
        carrier: h.dhpCarrier,
        flightNumber: h.dhpFlightNumber,
        bookingNumber: h.dhpBookingNumber,
        comment: h.dhpComment,
        tarmacPermission: h.dhpTarmacPermission,
        payAttention: h.dhpPayAttention,
        requestedDate:
          h.dhpRequestedDate != null &&
          new Date(h.dhpRequestedDate) instanceof Date
            ? this.dateService.getFormatedDateFromAPI(h.dhpRequestedDate)
            : null,
        reasonRequest: h.dhpReasonRequest
          ? h.dhpReasonRequest.split(",")
          : null,
        requestType: h.dhpRequestType,
        otherReasonRequest: h.dhpOtherReasonRequest,
        requestEscortType: {
          id: h.dhpRequestEscortType,
        },
        dateFrom:
          h.dhpDateFrom != null && new Date(h.dhpDateFrom) instanceof Date
            ? this.dateService.getFormatedDateFromAPI(h.dhpDateFrom)
            : null,
        dateTo:
          h.dhpDateTo != null && new Date(h.dhpDateTo) instanceof Date
            ? this.dateService.getLocaleDate(h.dhpDateTo)
            : null,
        meetingPoint: h.dhpMeetingPoint,
        contactPersonName: h.dhpContactPersonName,
        contactPersonAddress: h.dhpContactPersonAddress,
        contactPersonPhonenumber: h.dhpContactPersonPhonenumber,
        valueOfPackage: h.dhpValueOfPackage,
        medicationName: h.dhpMedicationName,
        amount: h.dhpAmount,
        residenceName: h.dhpResidenceName,
        residenceAddress: h.dhpResidenceAddress,
        residencePhoneNumber: h.dhpResidencePhoneNumber,
        checkOutDate:
          h.dhpCheckoutDate != null &&
          new Date(h.dhpCheckoutDate) instanceof Date
            ? new Date(h.dhpCheckoutDate)
            : null,
        amountOfNights: h.dhpAmountOfNights,
        typeOfRoom: h.dhpTypeOfRoom,
        content: h.dhpContent,
        specialNeedsForTransport: h.dhpSpecialNeedsForTransport,
        linkedHelpPlan: h.parentHelpPlanId
          ? h.parentHelpPlanId
          : h.dhpLinkedHelpPlan,
        kindOfCosts: h.dhpKindOfCosts,
        otherCostType: h.dhpOtherCostType,
        chauffeurName: h.dhpChauffeurName,
        chauffeurTelephone: h.dhpChauffeurTelephone,
        carLocation: h.dhpCarLocation,
        dropOffLocation: h.dhpDropOffLocation,
        dropOffDate:
          h.dhpDateTime != null && new Date(h.dhpDateTime) instanceof Date
            ? this.dateService.getFormatedDateFromAPI(h.dhpDateTime)
            : null,
        toWhomAgreed: h.dhpToWhomAgreed,
        totalCosts: h.dhpTotalCosts,
        medicalSupportNeeded: h.dhpMedicalSupportNeeded,
        medicalApproval: h.dhpMedicalApproval,
        legRest: h.dhpLegrest,
        stretcher: h.dhpStretcher,
        meetandAssist: h.dhpMeetAndAssist,
        wheelchair: h.dhpWheelchair,
        oxygen: h.dhpOxygen,
        amountOfOxygen: h.dhpAmountOfOxygen,
      };
      helpPlan.hpdHelpPlan = new IntakeHelpPlansModel();
      helpPlan.hpdHelpPlan.hplId = h.helpPlanId;
      helpPlan.hpdHelpPlan.hplCode = h.helpPlanCode;
      helpPlan.hpdHelpPlan.hplName = h.helpPlanName; 

      helpPlan.hpdHelpPlanType = h.helpPlanTypeId;
      helpPlan.hpdHelpPlanTypeName = h.helpPlanTypeName;
      helpPlan.hpdSupplierName = h.supplierId;
       helpPlan.orderingDate = h.orderingDate
      helpPlan.assignmentId = h.assignmentIdtMode
      helpPlans.push(helpPlan);
       i++;
    });

    _intake.intake.helpPlans = helpPlans;
    _intake.intake.linkedDossiers = dossier.linkedDossiers;
    let _steps = _intake.steps;
    let caseType = _intake.intake.policy.cause;
    _steps.forEach((s) => {
      s.isActive = true;
        if (s.label == "Travel" && caseType.ctyHasTravelStep != undefined)
        s.enabled = caseType.ctyHasTravelStep;
        if (s.label == "Party" && caseType.ctyHasFellowTravellersStep != undefined)
        s.enabled = caseType.ctyHasFellowTravellersStep;
        if (s.label == "ADL" && caseType.ctyHasAdlStep != undefined)
        s.enabled = caseType.ctyHasAdlStep;
        if (s.label == "DBC" && caseType.ctyHasDbcStep != undefined)
        s.enabled = caseType.ctyHasDbcStep;
    });
    return _intake;
  }

  mappingHelpPlansToIntake(helpPlansData)
  {
    let helpPlans: HelpPlanDetailsModel[] = [];
    helpPlansData.forEach(h => {
      let helpPlan = new HelpPlanDetailsModel();
      helpPlan.dhpCreatedDate = new Date(h.dhpCreatedDate);
      helpPlan.parentHelpPlanId = h.parentHelpPlanId;
      helpPlan.hpdId = h.dossierHelpPlanId;
      helpPlan.hpdCode = h.helpPlanCode.trim();
      helpPlan.dossierHelpPlanId = h.dossierHelpPlanId;
      helpPlan.hpdHelpPlanType = h.helpPlanTypeId;
      helpPlan.hpdHelpPlan = h.helpPlanId;
      helpPlan.workingOrder = h.workingOrder;
      helpPlan.concernedPersonList = [];
       h.concernedPersonHelpPlans.forEach(cp => {
         let concernedPerson = new ConcernedPersonModel();
        concernedPerson.dhpId = cp.dhpId;
         concernedPerson.ipaId = cp.ipaId;
         concernedPerson.chpId = cp.chpId;
         helpPlan.concernedPersonList.push(concernedPerson);
       });
      helpPlan.travelLegList = [];
       h.travelLegs.forEach(tl => {
        let travelLeg = new TravelLegModel();

        tl.tlDepartureDate = this.dateService.getFormatedDateFromAPI(tl.tlDepartureDate);
        tl.tlArrivalDate = this.dateService.getFormatedDateFromAPI(tl.tlArrivalDate);
        travelLeg = tl;
        helpPlan.travelLegList.push(travelLeg);
      });
      helpPlan.services = [];
      if(h.services){
        h.services.forEach(service => {
          helpPlan.services.push(service);
        });
      }
      helpPlan.proformaInvoiceList = [];
      if( h.workingOrderLines){
        h.workingOrderLines.forEach(pr => {
       let proformaInvoice = new PieceLayoutModel();
       proformaInvoice = pr;
       helpPlan.proformaInvoiceList.push(proformaInvoice);
        });
      }
      helpPlan.hdSpecific = {
        rmrRepatmortalremains: h.repatMortalRemains,
        rmrComment: h.rmrComment,
        tdComment: h.tdComment,
        tdTransferDepartureComment: h.tdTransferDepartureComment,
        tdTransferArrivalComment: h.tdTransferArrivalComment,
        tdisTranferDeparture: h.tdIsTransferDeparture,
        tdisTransferArrival: h.tdIsTransferArrival,
        tdisTravelneeded: h.tdIsTravelneeded,
        Request: {
          id: h.request,
        },
        hdBSN: h.hdBsn,
        hdComment: h.hdComment,
        hdDefinite: h.hdIsDefinite,
        hdDepartment: h.hdDepartment,
        hdHealthInsuranceAlarmcenter: h.hdHealthInsuranceAlarmcenter,
        hdIntensiveCare: h.hdIsIntensiveCare,
        hdIntensiveCareFromDate: this.dateService.getFormatedDateFromAPI(
          h.hdIntensiveCareFromDate
        ),
        hdIntensiveCareToDate: h.hdIntensiveCareToDate,
        hdRequestFromDate: this.dateService.getFormatedDateFromAPI(
          h.hdRequestFromDate
        ),
        hdRequestToDate: this.dateService.getFormatedDateFromAPI(
          h.hdRequestToDate
        ),
        hdRoomNumber: h.hdRoomNumber,
        hdTravelInsuranceAlarmcenter: h.hdTravelInsuranceAlarmcenter,
        hdisTransferArrival: h.hdisTransferArrival,
        hdisTransferDeparture: h.hdisTransferDeparture,

        otdBSN: h.otdBSN,
        otdComment: h.otdComment,
        otdDate: this.dateService.getFormatedDateFromAPI(h.otdDate),
        otdHealthInsuranceAlarmcenter: h.otdHealthInsuranceAlarmcenter,
        otdTravelInsuranceAlarmcenter: h.otdTravelInsuranceAlarmcenter,
        otdisTransferArrival: h.otdisTransferArrival,
        otdisTransferDeparture: h.otdisTransferDeparture,

        tadLinkedHelpPlan: h.tadLinkedHelpPlan
          ? h.tadLinkedHelpPlan
          : h.dhpLinkedHelpPlan,
        tadDateTime: this.dateService.getFormatedDateFromAPI(h.tadDateTime),
        tadFrom: h.tadFrom,
        tadTo: h.tadTo,
        tadTransportMode: h.tadTransportMode,

        tddLinkedHelpPlan: h.tddLinkedHelpPlan
          ? h.tddLinkedHelpPlan
          : h.dhpLinkedHelpPlan,
        tddDateTime: this.dateService.getFormatedDateFromAPI(h.tddDateTime),
        tddFrom: h.tddFrom,
        tddTo: h.tddTo,
        tddTransportMode: h.tddTransportMode,
        client: {
          value: h.dhpClient,
        },
        contractedSupplier: {
          value: h.dhpContractedSupplier,
        },
        otherSupplier: {
          value: h.dhpOtherSubContractorId,
        },
        paymentType: h.dhpPaymentType,
        product: h.dhpProduct,
        sosGuarantee_sosEhic: h.dhpSosGuarantee,
        status: { code: h.dhpStatus, shortName: h.dhpStatus },
        approvedGuaranteeByMedicalTeamUntil:
          h.dhpApprovedGuaranteeByMedicalUntil,
        luggage: h.dhpLuggage,
        repatMedicalUrgent: h.dhpIsRepatriationMedicalUrgent,
        transportationMode: h.dhpTrasportationMode,
        departureCountry: { iso3Code: h.dhpDepartureCountry },
        departureLocation: h.dhpDepartureLocation,
        departureAirport: { arpId: h.dhpDepartureAirport },
        departureDateTime:
          h.dhpDepartureDateTime != null &&
          new Date(h.dhpDepartureDateTime) instanceof Date
            ? this.dateService.getFormatedDateFromAPI(h.dhpDepartureDateTime)
            : null,
        arrivalLocation: h.dhpArrivalLocation,
        arrivalCountry: { iso3Code: h.dhpArrivalCountry },
        arrivalAirport: { arpId: h.dhpArrivalAirport },
        arrivalDateTime:
          h.dhpArrivalDateTime != null &&
          new Date(h.dhpArrivalDateTime) instanceof Date
            ? this.dateService.getLocaleDate(h.dhpArrivalDateTime)
            : null,
        carrier: h.dhpCarrier,
        flightNumber: h.dhpFlightNumber,
        bookingNumber: h.dhpBookingNumber,
        comment: h.dhpComment,
        tarmacPermission: h.dhpTarmacPermission,
        payAttention: h.dhpPayAttention,
        requestedDate:
          h.dhpRequestedDate != null &&
          new Date(h.dhpRequestedDate) instanceof Date
            ? this.dateService.getFormatedDateFromAPI(h.dhpRequestedDate)
            : null,
        reasonRequest: h.dhpReasonRequest
          ? h.dhpReasonRequest.split(",")
          : null,
        requestType: h.dhpRequestType,
        otherReasonRequest: h.dhpOtherReasonRequest,
        requestEscortType: {
          id: h.dhpRequestEscortType,
        },
        dateFrom:
          h.dhpDateFrom != null && new Date(h.dhpDateFrom) instanceof Date
            ? this.dateService.getFormatedDateFromAPI(h.dhpDateFrom)
            : null,
        dateTo:
          h.dhpDateTo != null && new Date(h.dhpDateTo) instanceof Date
            ? this.dateService.getLocaleDate(h.dhpDateTo)
            : null,
        meetingPoint: h.dhpMeetingPoint,
        contactPersonName: h.dhpContactPersonName,
        contactPersonAddress: h.dhpContactPersonAddress,
        contactPersonPhonenumber: h.dhpContactPersonPhonenumber,
        valueOfPackage: h.dhpValueOfPackage,
        medicationName: h.dhpMedicationName,
        amount: h.dhpAmount,
        residenceName: h.dhpResidenceName,
        residenceAddress: h.dhpResidenceAddress,
        residencePhoneNumber: h.dhpResidencePhoneNumber,
        checkOutDate:
          h.dhpCheckoutDate != null &&
          new Date(h.dhpCheckoutDate) instanceof Date
            ? new Date(h.dhpCheckoutDate)
            : null,
        amountOfNights: h.dhpAmountOfNights,
        typeOfRoom: h.dhpTypeOfRoom,
        content: h.dhpContent,
        specialNeedsForTransport: h.dhpSpecialNeedsForTransport,
        linkedHelpPlan: h.parentHelpPlanId
          ? h.parentHelpPlanId
          : h.dhpLinkedHelpPlan,
        kindOfCosts: h.dhpKindOfCosts,
        otherCostType: h.dhpOtherCostType,
        chauffeurName: h.dhpChauffeurName,
        chauffeurTelephone: h.dhpChauffeurTelephone,
        carLocation: h.dhpCarLocation,
        dropOffLocation: h.dhpDropOffLocation,
        dropOffDate:
          h.dhpDateTime != null && new Date(h.dhpDateTime) instanceof Date
            ? this.dateService.getFormatedDateFromAPI(h.dhpDateTime)
            : null,
        toWhomAgreed: h.dhpToWhomAgreed,
        totalCosts: h.dhpTotalCosts,
        medicalSupportNeeded: h.dhpMedicalSupportNeeded,
        medicalApproval: h.dhpMedicalApproval,
        legRest: h.dhpLegrest,
        stretcher: h.dhpStretcher,
        meetandAssist: h.dhpMeetAndAssist,
        wheelchair: h.dhpWheelchair,
        oxygen: h.dhpOxygen,
        amountOfOxygen: h.dhpAmountOfOxygen,
      };
      helpPlan.hpdHelpPlan = new IntakeHelpPlansModel();
      helpPlan.hpdHelpPlan.hplId = h.helpPlanId;
      helpPlan.hpdHelpPlan.hplCode = h.helpPlanCode;
      helpPlan.hpdHelpPlan.hplName = h.helpPlanName; 

      helpPlan.hpdHelpPlanType = h.helpPlanTypeId;
      helpPlan.hpdHelpPlanTypeName = h.helpPlanTypeName;
      helpPlan.hpdSupplierName = h.supplierId;
       helpPlan.orderingDate = h.orderingDate
      helpPlan.assignmentId = h.assignmentIdtMode
      helpPlans.push(helpPlan);
    });

    return helpPlans;
  }
  
  helpPlanFromApi(dossierHelpPlan){
    let helpPlan: HelpPlanDetailsModel= new HelpPlanDetailsModel();
      helpPlan.dhpCreatedDate = new Date(dossierHelpPlan.dhpCreatedDate);
      helpPlan.parentHelpPlanId = dossierHelpPlan.parentHelpPlanId;
      helpPlan.hpdId = dossierHelpPlan.dhpId;
      helpPlan.hpdCode = dossierHelpPlan.helpPlan.hplCode.trim();
      helpPlan.dossierHelpPlanId = dossierHelpPlan.dhpId;
      helpPlan.hpdHelpPlanType = dossierHelpPlan.helpPlanType;
      helpPlan.hpdHelpPlan = dossierHelpPlan.helpPlan;
      helpPlan.workingOrder = dossierHelpPlan.workingOrder;
      helpPlan.selectedTravelLegId = dossierHelpPlan.selectedTravelLegId;
      helpPlan.concernedPersonList = [];
      dossierHelpPlan.concernedPersonHelpPlans.forEach(cp => {
         let concernedPerson = new ConcernedPersonModel();
        concernedPerson.dhpId = cp.dhpId;
         concernedPerson.ipaId = cp.ipaId;
         helpPlan.concernedPersonList.push(concernedPerson);
       });
      helpPlan.travelLegList = [];
      dossierHelpPlan.travelLegs.forEach(tl => {
        let travelLeg = new TravelLegModel();
        tl.tlDepartureDate = this.dateService.getFormatedDateFromAPI(tl.tlDepartureDate);
        tl.tlArrivalDate = this.dateService.getFormatedDateFromAPI(tl.tlArrivalDate);
        travelLeg = tl;
        helpPlan.travelLegList.push(travelLeg);
      });
      helpPlan.services = [];
      if(dossierHelpPlan.services){
        dossierHelpPlan.services.forEach(service => {
          helpPlan.services.push(service);
        });
      }
      helpPlan.proformaInvoiceList = [];
      if( dossierHelpPlan.workingOrderLines){
        dossierHelpPlan.workingOrderLines.forEach(pr => {
       let proformaInvoice = new PieceLayoutModel();
       proformaInvoice = pr;
       helpPlan.proformaInvoiceList.push(proformaInvoice);
        });
      }
      helpPlan.hdSpecific = {
        rmrRepatmortalremains: dossierHelpPlan.repatMortalRemains,
        rmrComment: dossierHelpPlan.dhpRmrComment,
        tdComment: dossierHelpPlan.dhpTdComment,
        tdTransferDepartureComment: dossierHelpPlan.dhpTdTransferDepartureComment,
        tdTransferArrivalComment: dossierHelpPlan.dhpTdTransferArrivalComment,
        tdisTranferDeparture: dossierHelpPlan.dhpTdIsTransferDeparture,
        tdisTransferArrival: dossierHelpPlan.dhpTdIsTransferArrival,
        tdisTravelneeded: dossierHelpPlan.dhpTdIsTravelneeded,
        Request: {
          id: dossierHelpPlan.dhpRequest
        },
        hdBSN: dossierHelpPlan.dhpHdBsn,
        hdComment: dossierHelpPlan.dhpHdComment,
        hdDefinite: dossierHelpPlan.dhpHdIsDefinite,
        hdDepartment: dossierHelpPlan.dhpHdDepartment,
        hdHealthInsuranceAlarmcenter: dossierHelpPlan.dhpHdHealthInsuranceAlarmcenter,
        hdIntensiveCare: dossierHelpPlan.dhpHdIsIntensiveCare,
        hdIntensiveCareFromDate: this.dateService.getFormatedDateFromAPI(dossierHelpPlan.dhpHdIntensiveCareFromDate),
        hdIntensiveCareToDate: dossierHelpPlan.dhpHdIntensiveCareToDate,
        hdRequestFromDate: this.dateService.getFormatedDateFromAPI(dossierHelpPlan.dhpHdRequestFromDate),
        hdRequestToDate: this.dateService.getFormatedDateFromAPI(dossierHelpPlan.dhpHdRequestToDate),
        hdRoomNumber: dossierHelpPlan.dhpHdRoomNumber,
        hdTravelInsuranceAlarmcenter: dossierHelpPlan.dhpHdTravelInsuranceAlarmcenter,
        hdisTransferArrival: dossierHelpPlan.dhpHdisTransferArrival,
        hdisTransferDeparture: dossierHelpPlan.dhpHdisTransferDeparture,

        otdBSN: dossierHelpPlan.dhpOtdBSN,
        otdComment: dossierHelpPlan.dhpOtdComment,
        otdDate: this.dateService.getFormatedDateFromAPI(dossierHelpPlan.dhpOtdDate),
        otdHealthInsuranceAlarmcenter: dossierHelpPlan.dhpOtdHealthInsuranceAlarmcenter,
        otdTravelInsuranceAlarmcenter: dossierHelpPlan.dhpOtdTravelInsuranceAlarmcenter,
        otdisTransferArrival: dossierHelpPlan.dhpOtdisTransferArrival,
        otdisTransferDeparture: dossierHelpPlan.dhpOtdisTransferDeparture,

        tadLinkedHelpPlan: dossierHelpPlan.dhpTadLinkedHelpPlan ? dossierHelpPlan.dhpTadLinkedHelpPlan: dossierHelpPlan.dhpLinkedHelpPlan,
        tadDateTime: this.dateService.getFormatedDateFromAPI(dossierHelpPlan.dhpTadDateTime),
        tadFrom: dossierHelpPlan.dhpTadFrom,
        tadTo: dossierHelpPlan.dhpTadTo,
        tadTransportMode: dossierHelpPlan.dhpTadTransportMode,

        tddLinkedHelpPlan: dossierHelpPlan.dhpTddLinkedHelpPlan ? dossierHelpPlan.dhpTddLinkedHelpPlan : dossierHelpPlan.dhpLinkedHelpPlan,
        tddDateTime: this.dateService.getFormatedDateFromAPI(dossierHelpPlan.dhpTddDateTime),
        tddFrom: dossierHelpPlan.dhpTddFrom,
        tddTo: dossierHelpPlan.dhpTddTo,
        tddTransportMode: dossierHelpPlan.dhpTddTransportMode,
        client: {
          value: dossierHelpPlan.dhpClient
        },
        contractedSupplier: {
          value: dossierHelpPlan.dhpContractedSupplier
        },
        otherSupplier: {
          value: dossierHelpPlan.dhpOtherSubContractorId
        },
        paymentType: dossierHelpPlan.dhpPaymentType,
        product: dossierHelpPlan.dhpProduct,
        sosGuarantee_sosEhic: dossierHelpPlan.dhpSosGuarantee,
        status: {code : dossierHelpPlan.dhpStatus , shortName: dossierHelpPlan.dhpStatus },
        approvedGuaranteeByMedicalTeamUntil: dossierHelpPlan.dhpApprovedGuaranteeByMedicalUntil,
        luggage: dossierHelpPlan.dhpLuggage,
        repatMedicalUrgent: dossierHelpPlan.dhpIsRepatriationMedicalUrgent,
        transportationMode: dossierHelpPlan.dhpTrasportationMode,
        departureCountry : {iso3Code : dossierHelpPlan.dhpDepartureCountry},
        departureLocation : dossierHelpPlan.dhpDepartureLocation,
        departureAirport : {arpId : dossierHelpPlan.dhpDepartureAirport},
        departureDateTime : dossierHelpPlan.dhpDepartureDateTime != null && new Date( dossierHelpPlan.dhpDepartureDateTime) instanceof Date ? this.dateService.getFormatedDateFromAPI(dossierHelpPlan.dhpDepartureDateTime): null,
        arrivalLocation :  dossierHelpPlan.dhpArrivalLocation,
        arrivalCountry : {iso3Code : dossierHelpPlan.dhpArrivalCountry},
        arrivalAirport : {arpId : dossierHelpPlan.dhpArrivalAirport},
        arrivalDateTime : dossierHelpPlan.dhpArrivalDateTime != null && new Date( dossierHelpPlan.dhpArrivalDateTime) instanceof Date ? this.dateService.getLocaleDate( dossierHelpPlan.dhpArrivalDateTime): null,
        carrier : dossierHelpPlan.dhpCarrier,
        flightNumber : dossierHelpPlan.dhpFlightNumber,
        bookingNumber : dossierHelpPlan.dhpBookingNumber,
        comment : dossierHelpPlan.dhpComment,
        tarmacPermission : dossierHelpPlan.dhpTarmacPermission,
        payAttention : dossierHelpPlan.dhpPayAttention,
        requestedDate: dossierHelpPlan.dhpRequestedDate != null && new Date( dossierHelpPlan.dhpRequestedDate) instanceof Date ? new Date( dossierHelpPlan.dhpRequestedDate): null,
        reasonRequest: dossierHelpPlan.dhpReasonRequest?dossierHelpPlan.dhpReasonRequest.split(",") : null,
        requestType: dossierHelpPlan.dhpRequestType,
        otherReasonRequest: dossierHelpPlan.dhpOtherReasonRequest,
        requestEscortType: {
          id: dossierHelpPlan.dhpRequestEscortType
        },
        dateFrom: dossierHelpPlan.dhpDateFrom != null && new Date( dossierHelpPlan.dhpDateFrom) instanceof Date ? this.dateService.getFormatedDateFromAPI(dossierHelpPlan.dhpDateFrom): null,
        dateTo: dossierHelpPlan.dhpDateTo!= null && new Date( dossierHelpPlan.dhpDateTo) instanceof Date ? this.dateService.getLocaleDate(dossierHelpPlan.dhpDateTo): null,
        meetingPoint: dossierHelpPlan.dhpMeetingPoint,
        contactPersonName: dossierHelpPlan.dhpContactPersonName,
        contactPersonAddress: dossierHelpPlan.dhpContactPersonAddress,
        contactPersonPhonenumber: dossierHelpPlan.dhpContactPersonPhonenumber,
        valueOfPackage: dossierHelpPlan.dhpValueOfPackage,
        medicationName: dossierHelpPlan.dhpMedicationName,
        amount: dossierHelpPlan.dhpAmount,
        residenceName : dossierHelpPlan.dhpResidenceName,
        residenceAddress : dossierHelpPlan.dhpResidenceAddress,
        residencePhoneNumber : dossierHelpPlan.dhpResidencePhoneNumber,
        checkOutDate : dossierHelpPlan.dhpCheckoutDate!= null && new Date(dossierHelpPlan.dhpCheckoutDate) instanceof Date ? new Date(dossierHelpPlan.dhpCheckoutDate): null,
        amountOfNights : dossierHelpPlan.dhpAmountOfNights,
        typeOfRoom : dossierHelpPlan.dhpTypeOfRoom,
        content: dossierHelpPlan.dhpContent,
        specialNeedsForTransport: dossierHelpPlan.dhpSpecialNeedsForTransport,
        linkedHelpPlan: dossierHelpPlan.parentHelpPlanId ? dossierHelpPlan.parentHelpPlanId: dossierHelpPlan.dhpLinkedHelpPlan,
        kindOfCosts: dossierHelpPlan.dhpKindOfCosts,
        otherCostType: dossierHelpPlan.dhpOtherCostType,
        chauffeurName: dossierHelpPlan.dhpChauffeurName,
        chauffeurTelephone: dossierHelpPlan.dhpChauffeurTelephone,
        carLocation: dossierHelpPlan.dhpCarLocation,
        dropOffLocation: dossierHelpPlan.dhpDropOffLocation,
        dropOffDate: dossierHelpPlan.dhpDateTime!= null && new Date( dossierHelpPlan.dhpDateTime) instanceof Date ? this.dateService.getFormatedDateFromAPI(dossierHelpPlan.dhpDateTime):null,
        toWhomAgreed: dossierHelpPlan.dhpToWhomAgreed,
        totalCosts: dossierHelpPlan.dhpTotalCosts,
        medicalSupportNeeded: dossierHelpPlan.dhpMedicalSupportNeeded ,
        medicalApproval: dossierHelpPlan.dhpMedicalApproval ,
        legRest: dossierHelpPlan.dhpLegrest,
        stretcher: dossierHelpPlan.dhpStretcher,
        meetandAssist: dossierHelpPlan.dhpMeetAndAssist ,
        wheelchair: dossierHelpPlan.dhpWheelchair,
        oxygen: dossierHelpPlan.dhpOxygen ,
        amountOfOxygen : dossierHelpPlan.dhpAmountOfOxygen,
      };
      helpPlan.hpdHelpPlan = new IntakeHelpPlansModel();
      helpPlan.hpdHelpPlan.hplId = dossierHelpPlan.helpPlan.hplId;
      helpPlan.hpdHelpPlan.hplCode = dossierHelpPlan.helpPlan.hplCode;
      helpPlan.hpdHelpPlan.hplName = dossierHelpPlan.helpPlan.hplName;      
      
      helpPlan.hpdHelpPlanType = dossierHelpPlan.helpPlanType;
      helpPlan.hpdHelpPlanTypeName = dossierHelpPlan.dhpHelpPlanTypeName;
      helpPlan.hpdSupplierName = dossierHelpPlan.dhpSupplierId;
      helpPlan.hpdSupplier = dossierHelpPlan.hpdSupplier;
      helpPlan.orderingDate = dossierHelpPlan.orderingDate
      helpPlan.assignmentId = dossierHelpPlan.assignmentId
      return helpPlan;
  }
  

  populateTravels(dossier){
    let travels = [];
      dossier.travels.forEach(travel=>{
        let _travel = new TravelDetailModel();
        if (travel != null) {
          _travel.tdPurpose = travel.purpose;
          _travel.tdType = travel.type;
          _travel.tdCarrier = travel.carrier;
          _travel.tdGroup = travel.group;
          _travel.tdAdultsNumber = travel.adultsNumber;
          _travel.tdChildrenNumber = travel.childrenNumber;
          _travel.tdFrom = travel.from;
          _travel.tdTo = travel.to;
          _travel.tdStartDate = travel.startDate;
          _travel.tdReturnDate = travel.returnDate;
          _travel.tdGoingFlightNumber = travel.goingFlightNumber;
          _travel.tdIsReturnBooked = travel.isReturnBooked;
          _travel.tdReturnFlightNumber = travel.returnFlightNumber;
          _travel.tdIsTicketChangeable = travel.isTicketChangeable;
          _travel.tdBookingAgency = travel.bookingAgency;
          _travel.tdBookingAgencyPhoneNumber =
            travel.bookingAgencyPhoneNumber;
          _travel.tdIsTicketChangeable = travel.isTicketChangeable;
          _travel.tdBookingNumber = travel.bookingNumber;
          _travel.tdTourOperator = travel.tourOperator;
          _travel.tdTravelPlan = travel.travelPlan;
          _travel.tdAssignmentId = travel.assignmentId;
  
          travels.push(_travel);
        }      
      });
    return travels;    
  }

  populateCaseDetail(caseDetail)
  {
    let cause = new CaseModel();
    cause.caseDetailId = caseDetail.caseDetailId;
    //Diagnose Details
    if (caseDetail.diagnoseDetail != null) {
      let _diagnoseDetail = caseDetail.diagnoseDetail;
      let _diagnoseModel = new DiagnoseModel();
      _diagnoseModel = new DiagnoseModel();
      _diagnoseModel.diagnose = _diagnoseDetail.diagnose;
      _diagnoseModel.midOfficeDiagnoseTypeId =
        _diagnoseDetail.midOfficeDiagnoseTypeId;
      _diagnoseModel.cdICDDiagnose = _diagnoseDetail.icdDiagnoseId;
      _diagnoseModel.manualIcdDiagnose = _diagnoseDetail.manualIcdDiagnose;
      _diagnoseModel.cdICDCode = _diagnoseDetail.icdCode;
      _diagnoseModel.diagnosis = _diagnoseDetail.diagnosis;
      _diagnoseModel.medicalInformation = _diagnoseDetail.medicalInformation;
      _diagnoseModel.medicalHistory = _diagnoseDetail.medicalHistory;
      _diagnoseModel.nameOfGeneralPractioner =
        _diagnoseDetail.nameOfGeneralPractioner;
      _diagnoseModel.cityOfGeneralPractitioner =
        _diagnoseDetail.cityOfGeneralPractitioner;
      _diagnoseModel.nameSpecialist = _diagnoseDetail.nameSpecialist;
      _diagnoseModel.hospitalinNL = _diagnoseDetail.hospitalinNL;
      _diagnoseModel.phoneNumber = _diagnoseDetail.phoneNumber;
      _diagnoseModel.hasPermission = _diagnoseDetail.hasPermission;
      _diagnoseModel.cdNameofSpecialist = _diagnoseDetail.cdNameofSpecialist,
      _diagnoseModel.cdPhonenumberofSpecialist = _diagnoseDetail.cdPhonenumberofSpecialist,
      _diagnoseModel.cdPhonenumberForeignSpecialist = _diagnoseDetail.cdPhonenumberForeignSpecialist,
      _diagnoseModel.hospital = _diagnoseDetail.hospital;
      _diagnoseModel.mediacalComments = _diagnoseDetail.mediacalComments;
      _diagnoseModel.hasMedicalReport = _diagnoseDetail.hasMedicalReport;
      _diagnoseModel.hasFitFlyDocument = _diagnoseDetail.hasFitFlyDocument;
      _diagnoseModel.cdCanSendDocuments = _diagnoseDetail.canSendDocuments;
      _diagnoseModel.extraInformationComments =
        _diagnoseDetail.extraInformationComments;
      _diagnoseModel.isCategoryDiagnose = _diagnoseDetail.isCategoryDiagnose;
      _diagnoseModel.creationDate = _diagnoseDetail.creationDate;
      cause.diagnoseDetail = _diagnoseModel;
    }

    //General details
    if (caseDetail.generalDetail != null) {
      let _generalDetail = caseDetail.generalDetail;
      let _generalModel = new GeneralModel();
      _generalModel.value1 = _generalDetail.value1;
      _generalModel.value2 = _generalDetail.value2;
      _generalModel.value3 = _generalDetail.value3;
      _generalModel.value4 = _generalDetail.value4;
      cause.general = _generalModel;
    }

    //Death  details
    if (caseDetail.deathDetail != null) {
      let _deathDetail = caseDetail.deathDetail;
      let _deathModel = new DeathDetailModel();
      _deathModel.dthDateOfDeath = _deathDetail.dateOfDeath;
      _deathModel.dthCauseOfDeath = _deathDetail.causeOfDeath;
      _deathModel.dthIsPoliceInvolved = _deathDetail.isPoliceInvolved;
      _deathModel.dthIsAutopy = _deathDetail.isAutopsy;
      _deathModel.dthDescription = _deathDetail.description;
      let deadPerson = new DeadPersonModel();
      deadPerson.dpFirstName = _deathDetail.dpiFirstName;
      deadPerson.dpLastName = _deathDetail.dpiLastName;
      deadPerson.dpPostalCode = _deathDetail.dpiPostalCode;
      deadPerson.dpHouseNumber = _deathDetail.dpiHouseNumber;
      deadPerson.dpHouseNumberAddition = _deathDetail.dpiHouseNumberAddition;
      deadPerson.dpStreetName = _deathDetail.dpiStreetName;
      deadPerson.dpCity = _deathDetail.dpiCity;
      deadPerson.dpCountry = _deathDetail.dpiCountry;
      deadPerson.dpMaidenName = _deathDetail.dpiMaidenName;
      deadPerson.dpDateOfBirth = _deathDetail.dpiDateOfBirth;
      deadPerson.dpBsn = _deathDetail.dpiBSN;
      deadPerson.dpLength = _deathDetail.dpiLength ? _deathDetail.dpiLength.toString() : null;
      deadPerson.dpWeight = _deathDetail.dpiWeight ? _deathDetail.dpiWeight.toString() : null;
      deadPerson.dpBirthPlace = _deathDetail.dpiBirthPlace;
      deadPerson.dpProfession = _deathDetail.dpiProfession;
      deadPerson.dpReligion = _deathDetail.dpiReligion;
      deadPerson.dpWeddingDate = _deathDetail.dpiWeddingDate;
      deadPerson.dpPlaceOfMarriage = _deathDetail.dpiPlaceOfMarriae;
      deadPerson.dpIsFatherAlive = _deathDetail.dpiIsFatherAlive;
      deadPerson.dpFatherName = _deathDetail.dpiFatherName;
      deadPerson.dpIsMotherAlive = _deathDetail.dpiIsMotherAlive;
      deadPerson.dpMotherName = _deathDetail.dpiMotherName;
      deadPerson.dpWithPassport = _deathDetail.dpiWithPassport;
      deadPerson.dpHasPassportCopy = _deathDetail.dpiHasPassportCopy;
      deadPerson.dpIsJewelryTakenOff = _deathDetail.isJewelryTakenOff;
      deadPerson.dpHasLuggage = _deathDetail.dpiHasLuggage;
      deadPerson.dpFuneralType = _deathDetail.kindOfFuneral;
      deadPerson.dpSpouseFirstName = _deathDetail.dsiFirstName;
      deadPerson.dpSpouseLastName = _deathDetail.dsiLastName;
      deadPerson.dpSpouseDateOfBirth = _deathDetail.dsiDateOfBirth;
      deadPerson.dpSpousePlaceOfBirth = _deathDetail.dsiBirthPlace;
      deadPerson.dpContactPersonFirstName = _deathDetail.cpiFirstName;
      deadPerson.dpContactPersonLastName = _deathDetail.cpiLastName;
      deadPerson.dpContactPersonPhoneNumber = _deathDetail.cpiPhoneNumber;
      deadPerson.dpContactPersonSpeaksEnglish = _deathDetail.cpiSpeaksEnglish;
      deadPerson.dpMluggageInformation = _deathDetail.dpiLuggageInformation;
      deadPerson.dpSignature = _deathDetail.dpiSignature;
      _deathModel.deadPerson = deadPerson;
      _deathModel.dutchCoroner = this.generatCoroner(_deathDetail.dutchCoroner);
      _deathModel.foreignCorner = this.generatCoroner(_deathDetail.foreignCoroner);
      cause.death = _deathModel;
    }

    //Callback Details
    if (caseDetail.callbackDetail != null) {
      let _callBackDetail = caseDetail.callbackDetail
      let _callBackModel = new CallBackModel();
      _callBackModel.address = _callBackDetail.address;
      _callBackModel.airline = _callBackDetail.airline;
      _callBackModel.bookingNumber = _callBackDetail.bookingNumber;
      _callBackModel.city = _callBackDetail.city;
      _callBackModel.comment = _callBackDetail.comment;
      _callBackModel.country = new Country();
      _callBackModel.country.id = _callBackDetail.countryId;
      _callBackModel.dateOfBirth = _callBackDetail.dateOfBirth;
      _callBackModel.deathDate = _callBackDetail.deathDate;
      _callBackModel.firstName = _callBackDetail.firstName;
      _callBackModel.from = _callBackDetail.from;
      _callBackModel.funeralDate = _callBackDetail.funeralDate;
      _callBackModel.hospitalizationDate = _callBackDetail.hospitalizationDate;
      _callBackModel.houseNumber = _callBackDetail.houseNumber;
      _callBackModel.isAirLineBooked = _callBackDetail.isAirLineBooked;
      _callBackModel.journeyType = _callBackDetail.journeyType;
      _callBackModel.lastName = _callBackDetail.lastName;
      _callBackModel.luggage = _callBackDetail.luggage;
      _callBackModel.numberOfFellowTravellers = _callBackDetail.numberOfFellowTravellers;
      _callBackModel.postalCode = _callBackDetail.postalCode;
      _callBackModel.reason = _callBackDetail.reason;
      _callBackModel.gender = _callBackDetail.gender;
      _callBackModel.relationId = _callBackDetail.relationId;
      _callBackModel.residence = _callBackDetail.residence;
      _callBackModel.returnDate = _callBackDetail.returnDate;
      _callBackModel.situation = _callBackDetail.situation;
      _callBackModel.to = _callBackDetail.to;
      _callBackModel.wheelchair = _callBackDetail.wheelchair;
      cause.callBack = _callBackModel;
    }
    return cause;
  }

  populateCaseDetails(dossier){
    let cases: CaseModel[] = [];
    dossier.caseDetails.forEach(caseDetail=>{
      const cause = this.populateCaseDetail(caseDetail);
      cases.push(cause);
    });
    return cases;
  }

  populateCauses(dossier){
    let causes = [];
      dossier.policy.caseTypes.forEach(caseType=>{
        let cause = new CaseType();
        cause.assignmentId = caseType.assignmentId;
        cause.ctyId = caseType.ctyId;
        cause.ctyName = caseType.ctyName;
        cause.clientPolicyControlExceptions = caseType.clientPolicyControlExceptions;
        cause.ctyHasPiaPolicy = caseType.ctyHasPiaPolicy;
        cause.ctyHasVecozoPolicy = caseType.ctyHasVecozoPolicy;
        cause.locations = [];
        cause.ctyCaseDetailId = caseType.ctyCaseDetailId;
        cause.caseDetailLabel = caseType.caseDetailLabel;
        cause.caseDetailName = caseType.caseDetailName;
        cause.ctyHasFellowTravellers = caseType.ctyHasFellowTravellers;
        cause.ctyHasAdl = caseType.ctyHasAdl;
        cause.ctyHasDbc = caseType.ctyHasDbc;
        cause.ctyHasTravelDetails = caseType.ctyHasTravelDetails;
        cause.ctyHasFellowTravellersStep = caseType.ctyHasFellowTravellers;
        cause.ctyHasTravelStep = caseType.ctyHasTravelDetails;
        cause.ctyHasRehospitalisationStep = caseType.ctyHasRehospitalisation;
        cause.ctyHasAdlStep = caseType.ctyHasAdl;
        cause.ctyHasDbcStep = caseType.ctyHasDbc;
            dossier.policy.caseType.caseTypeLocations.forEach((l) => {
                let location = new LocationType();
                location.lctId = l.lctId;
                location.lctName = l.lctName;
                location.lctIcon = l.lctIcon;
                location.lctIsSelected = l.lctIsSelected;
                location.locationDetails = [];
                let locationDetailList = dossier.locations.filter((r) => r.locationTypeId == l.lctId);
                if (locationDetailList.length > 0) {
                    locationDetailList.forEach(ldt => {
                        let detail: LocationDetailsModel = new LocationDetailsModel();
                        detail.ldName = location.lctName;
                        detail.ldAddress1 = ldt.address1;
                        detail.ldAddress2 = ldt.address2;
                        detail.ldSupplierId=ldt.supplierId
                        detail.ldCity = ldt.city;
                        detail.ldComment = ldt.comment;
                        detail.ldLongitude = ldt.longitude;
                        detail.ldLatitude = ldt.latitude;
                        detail.ldPostalCode = ldt.postalCode;
                        detail.ldCountry = new Country();
                        detail.ldCountry.id = ldt.country.id;
                        detail.ldCountry.name = ldt.country.name;
                        detail.ldTelephone = ldt.telephone;
                        detail.ldLocationTypeId = ldt.locationTypeId;
                        detail.ldLocationName = ldt.locationName;
                        detail.ldId = ldt.locationId;
                        location.locationDetails = [...location.locationDetails, detail];
                    });
                }
                cause.locations = [...cause.locations, location];
            });
    
        cause.helpPlans = [];
        caseType.caseTypeHelpPlans.forEach((h) => {
          let helpPlan = new IntakeHelpPlansModel();
          helpPlan.hplId = h.hplId;
          helpPlan.hplCode = h.hplCode;
          helpPlan.hplName = h.hplName;
          helpPlan.hplIsInIntake = h.hplIsInIntake;
          helpPlan.helpPlanTypeIds = h.helpPlanTypeIds;
          cause.helpPlans.push(helpPlan);
        });
    
        cause.helpPlanTypes = [];
        caseType.caseTypeHelpPlanTypes.forEach((h) => {
          let helpPlanType = new HelpPlanTypeModel();
          helpPlanType.htyId = h.HtyId;
          helpPlanType.htyCode = h.htyCode;
          helpPlanType.htyName = h.htyName;
          cause.helpPlanTypes.push(helpPlanType);
        });

        cause.caseTypeOrganizationUnits = caseType.caseTypeOrganizationUnits;
    
        causes.push(cause);
      });

      return causes;
  }

  fillIntakeLists(intake, params) {
    params.parties = [];
    params.policy.travelInsurancePolicies = [];
    params.policy.healthInsurancePolicies = [];
    params.policy.noInsurancePolicies = [];
    params.helpPlans = [];
    params.insuree.contactPersons = [];
    params.locations = [];
    if (intake.parties != undefined && intake.parties.length != 0) {
      intake.parties.forEach((p) => {
        params.parties.push(this.mapParty(p));
      });
    }
    intake.parties.forEach((item,index) => {
      params.parties[index].travelInsurances = [];
     if(item.ftdTravelInsurances != undefined && item.ftdTravelInsurances.length != 0)
     {
      item.ftdTravelInsurances.forEach((t) => {
        t.fellowTravellerId = item.fellowTravellerId;
        params.parties[index].travelInsurances.push(this.mapTravelInsurance(t,true));
    });
     }
    });
if (intake.policy.selectedtravelPolicies != undefined && intake.policy.selectedtravelPolicies.length != 0) {
  intake.policy.selectedtravelPolicies.forEach((t) => {
    t.assignmentId = intake.assignmentId;
    params.policy.travelInsurancePolicies.push(this.mapTravelInsurance(t,false));
  });
}

if (intake.policy.selectedhealthPolicies != undefined && intake.policy.selectedhealthPolicies.length != 0) {
  intake.policy.selectedhealthPolicies.forEach((h) => {
    h.assignmentId = intake.assignmentId;
    params.policy.healthInsurancePolicies.push(this.mapHealthInsurance(h));
  });
}

    if (intake.policy.noInsurancePolicies != undefined && intake.policy.noInsurancePolicies.length != 0) {
      intake.policy.noInsurancePolicies.forEach((nip) => {
        params.policy.noInsurancePolicies.push(this.mapNoInsurancePolicy(nip));
      });
    }
    if (intake.insuree.ContactPersons != undefined && intake.insuree.ContactPersons.length != 0) {
      intake.insuree.ContactPersons.forEach((cp) => {
        params.insuree.contactPersons.push(this.mapContactPerson(cp));
      });
    }

if (intake.dossierId == null && intake.helpPlans != undefined && intake.helpPlans.length != 0) {
  intake.helpPlans.forEach((hp) => {
    if(hp!=undefined)
    params.helpPlans.push(this.mapIntakeHelpPlans(hp));
  });
}

if (intake.policy.cause.locations != undefined && intake.policy.cause.locations.length != 0) {
  intake.policy.cause.locations.forEach((l: LocationType) => {
    if (l.locationDetails && l.locationDetails.length>0) {
      l.locationDetails.forEach(ldt=>{
        if(ldt.ldLocationTypeId !=null)
        params.locations.push(this.mapLocationPost(ldt,l.lctId));
      });
    }
  });
}
return params;
}

getLocaleDate(date: Date) {
return this.intakeService.getLocalDate(date);
}

  resetStateData(): IntakeModel {
    return {
      draftDossierNumber:null,
      steps: intakeStepsData,
      intake: new IntakeDataModel(),
      intakeDuration: new intakeTimeValueModel(),
      active: intakeStepsData.reduce((p, c) =>
        p.step < c.step && p.enabled ? p : c
      ),
      editMode: true,
      creationDate:null
    };
  }

private generatCoroner(coroner): CoronerModel {
let res = new CoronerModel();
res.corCountry = new Country();
if (coroner != null) {
  res.corName = coroner.name ? coroner.name : null;
  res.corCity = coroner.city ? coroner.city : null;
  res.corHouseNumber = coroner.houseNumber ? coroner.houseNumber : null;
  res.corHouseNumberAddition = coroner.houseNumberAddition ? coroner.houseNumberAddition : null;
  res.corContactPerson = coroner.contactPerson ? coroner.contactPerson : null;
  res.corCountry.id = coroner.countryId ? coroner.countryId : null;
  res.corPhoneNumber = coroner.phoneNumber ? coroner.phoneNumber : null;
  res.corPostalCode = coroner.postalCode ? coroner.postalCode : null;
  res.corStreetName = coroner.streetName ? coroner.streetName : null;
  return res;
}
else return null;
}


mapParty(fellowtraveller: FellowTraveller) {
return !fellowtraveller
  ? {}
  : {
    concernedPersonType: fellowtraveller.ftdConcernedPersonType.rcId,
    dossierId: fellowtraveller.dossierId,
    relationship: fellowtraveller.ftdInvolvedPartyRelationType?  fellowtraveller.ftdInvolvedPartyRelationType.iprtId : null,
    escortType: fellowtraveller.ftdEscortType,
    initials: fellowtraveller.ftdInitials,
    firstName: fellowtraveller.ftdFirstName,
    lastName: fellowtraveller.ftdLastName,
    maidenName: fellowtraveller.ftdIMaidenName,
    dateOfBirth: fellowtraveller.ftdDateOfBirth ? fellowtraveller.ftdDateOfBirth : null,
    gender: fellowtraveller.ftdGender ? fellowtraveller.ftdGender.toString() : '0',
    inactive: !fellowtraveller.ftdActive,
    streetName: fellowtraveller.ftdStreetName,
    houseNumber: fellowtraveller.ftdHouseNumber,
    houseNumberAddition: fellowtraveller.ftdHouseNumberAddition,
    address2: "",
    postalCode: fellowtraveller.ftdPostalCode,
    city: fellowtraveller.ftdCity,
    countryId: fellowtraveller.country ? fellowtraveller.country.id : null,
    phoneNumber:
      fellowtraveller.ftdPhoneNumber &&
        fellowtraveller.ftdPhoneNumber.toString()
        ? fellowtraveller.ftdPhoneNumber.toString()
        : null,
    phoneNumber2:
      fellowtraveller.ftdPhoneNumber2 &&
        fellowtraveller.ftdPhoneNumber2.toString()
        ? fellowtraveller.ftdPhoneNumber2.toString()
        : null,
    email: fellowtraveller.ftdEmail,
    remarks: fellowtraveller.ftdRemarks,
    fellowTravellerId: fellowtraveller.fellowTravellerId,
    healthInsurances: [],

    travelInsurances: [] =fellowtraveller.ftdTravelInsurances.map(m=> this.mapTravelInsurance(m,true)),
    hasSameTravelInsurance : fellowtraveller.ftdHasSameTravelInsurance
  };
}

mapTravelInsurance(travelInsurance: TravelInsurance,isFellowTraveller : boolean) {
  return !travelInsurance
    ? {}
    : {
      id: isNaN(Number(travelInsurance.id)) ? travelInsurance.id : null,
      lastName: travelInsurance.lastName,
      initials: travelInsurance.initials,
      policyNumber: travelInsurance.policyNumber,
      policyHolderInitials: travelInsurance.policyHolderInitials,
      policyHolderLastName: travelInsurance.policyHolderLastName,
      policyHolderStreet: travelInsurance.policyHolderStreet,
      policyHolderHouseNumber: travelInsurance.policyHolderHouseNumber,
      policyHolderHouseNumberAddOn:travelInsurance.policyHolderHouseNumberAddOn,
      policyHolderCity: travelInsurance.policyHolderCity,
      policyHolderZipCode: travelInsurance.policyHolderZipCode,
      policyHolderCountryCode: travelInsurance.policyHolderCountryCode,
      productCode: !isFellowTraveller ?  (travelInsurance.product && travelInsurance.product.productCode ? travelInsurance.product.productCode :null)
        : travelInsurance.productCode,
      productName: this.getProductName(isFellowTraveller,travelInsurance),
      productType: travelInsurance.productType,
      productId : this.getProductId(isFellowTraveller,travelInsurance),      
      insurerNumber: travelInsurance.insurerNumber,
      familySituation: travelInsurance.familyComposition,
      coverageArea: travelInsurance.coverageArea,
      coveredPerson: travelInsurance.coveredPerson,
      policyCommencementDate: travelInsurance.policyCommencementDate,
      otherAlarmcenter: travelInsurance.otherAlarmcenter,
      policyCheckDate: travelInsurance.policyCheckDate,
      personName: travelInsurance.personName,
      policyDetails: !isFellowTraveller ?(travelInsurance.coverageDetails ? travelInsurance.coverageDetails : travelInsurance.policyDetails)
        :travelInsurance.policyDetails,
      arrangedBy: travelInsurance.arrangedBy,
      expiryDate: travelInsurance.expiryDate,
      BeginTravelDate: travelInsurance.ptiBeginTravelDate,
      ReturnDate: travelInsurance.ptiReturnDate,
      alarmcenter: travelInsurance.ptiAlarmcenter? travelInsurance.ptiAlarmcenter : null,
      mandate:this.getMandate(isFellowTraveller,travelInsurance),
      intermediary: travelInsurance.ptiIntermediary,
      referenceDate:  this.getReferenceDate(isFellowTraveller,travelInsurance),
      travelAgency: travelInsurance.ptiTravelAgency,
      statusPolicyCheck: this.sharedService.hasProperty(travelInsurance,'ptiStatusPolicyCheck.id')? travelInsurance.ptiStatusPolicyCheck.id : this.sharedService.hasProperty(travelInsurance,'ptiStatusPolicyCheck')?travelInsurance.ptiStatusPolicyCheck:null,
      typePolicyCheck:  this.getTypePolicyCheck(isFellowTraveller,travelInsurance),
      policyOverview: travelInsurance.policyOverview,
      isManual: travelInsurance.ptiIsManual,
      comment: travelInsurance.ptiComment,
      medicalcosts: travelInsurance.medicalcosts,
      skiing: travelInsurance.skiing,
      crosscountryskiing: travelInsurance.crosscountryskiing,
      worldcoverage: travelInsurance.worldcoverage,
      europeancoverage: travelInsurance.europeancoverage,
      specialsports: travelInsurance.specialsports,
      other: travelInsurance.other,
      carassistance: travelInsurance.carassistance,
      insurerId: this.getInsurerId(isFellowTraveller,travelInsurance),
      mandatePhoneNumber:
        (travelInsurance.ptiMandatePhoneNumber &&
          travelInsurance.ptiMandatePhoneNumber.toString())
          ? travelInsurance.ptiMandatePhoneNumber.toString()
          : null,
      insurerPhoneNumber: travelInsurance.ptiInsurerPhoneNumber,
      intermediaryPhoneNumber:
        (travelInsurance.ptiIntermediaryPhoneNumber &&
          travelInsurance.ptiIntermediaryPhoneNumber.toString())
          ? travelInsurance.ptiIntermediaryPhoneNumber.toString()
          : null,
      travelAgencyPhoneNumber:
        (travelInsurance.ptiTravelAgencyPhoneNumber &&
          travelInsurance.ptiTravelAgencyPhoneNumber.toString())
          ? travelInsurance.ptiTravelAgencyPhoneNumber.toString()
          : null,
      fellowTravellerId: travelInsurance.fellowTravellerId,
      feeServiceId: this.getServicefee(isFellowTraveller,travelInsurance),
      chargedExpensesId: this.getChargeExpenses(isFellowTraveller,travelInsurance),
      alarmCenterId: this.getAlarmCenterId(isFellowTraveller,travelInsurance),
      clientId: this.getClient(isFellowTraveller, travelInsurance),
      involvedPartyId : travelInsurance.ptiInvolvedPartyId,
      involvedParty : travelInsurance.ptiInvolvedParty
    };
  }

  getAlarmCenterId(isFellowTraveller , travelInsurance){
    return !isFellowTraveller ?(travelInsurance.ptiMAlarmcenter ? travelInsurance.ptiMAlarmcenter.id :null)
    :this.sharedService.hasProperty(travelInsurance.ptiMAlarmcenter, 'id')?travelInsurance.ptiMAlarmcenter.id: travelInsurance.ptiMAlarmcenter
  }

  getProductId(isFellowTraveller , travelInsurance){
    return !isFellowTraveller ?(travelInsurance.product && travelInsurance.product.productId ? travelInsurance.product.productId :null)
      : this.sharedService.hasProperty(travelInsurance.product,'productId') ? travelInsurance.product.productId : travelInsurance.productId
  }

  getInsurerId(isFellowTraveller , travelInsurance){
    return !isFellowTraveller ?(travelInsurance.insurerId ? travelInsurance.insurerId : travelInsurance.ptiInsurer ? travelInsurance.ptiInsurer.id :null)
          : this.sharedService.hasProperty(travelInsurance.ptiInsurer,'id')? travelInsurance.ptiInsurer.id 
          :(travelInsurance.insurer?travelInsurance.insurer:travelInsurance.insurerId)
  }
  
  getProductName(isFellowTraveller , travelInsurance){
   return !isFellowTraveller ? (travelInsurance.product && travelInsurance.product.productName ? travelInsurance.product.productName : null)
      : this.sharedService.hasProperty(travelInsurance,'productName.productName')
      ?travelInsurance.productName.productName
      :(travelInsurance.productName?travelInsurance.productName:  travelInsurance.product ? travelInsurance.product.productName : null )
  }

  getMandate(isFellowTraveller , travelInsurance){
    return !isFellowTraveller ?  (this.sharedService.hasProperty(travelInsurance,'ptiMandate.id')?travelInsurance.ptiMandate.id: travelInsurance.ptiMandate)
    : (travelInsurance.mandate ? travelInsurance.mandate : travelInsurance.ptiMandate ? travelInsurance.ptiMandate.id : null);
  }

  getTypePolicyCheck(isFellowTraveller, travelInsurance){
    return !isFellowTraveller ? (travelInsurance.ptiTypePolicyCheck) :(travelInsurance.ptiTypePolicyCheck ? travelInsurance.ptiTypePolicyCheck : travelInsurance.typePolicyCheck);
  }

  getServicefee(isFellowTraveller, travelInsurance){
    return !isFellowTraveller ?(travelInsurance.ptiServiceFees ? travelInsurance.ptiServiceFees.id :null)
    : travelInsurance.ptiServiceFees ? travelInsurance.ptiServiceFees.id : null;
  }

  getChargeExpenses(isFellowTraveller, travelInsurance){
    return !isFellowTraveller ?(travelInsurance.ptiChargedExpenses ? travelInsurance.ptiChargedExpenses.id :null)
    :travelInsurance.ptiChargedExpenses? travelInsurance.ptiChargedExpenses.id : null;
  }

  getClient(isFellowTraveller, travelInsurance){
    return !isFellowTraveller ?(travelInsurance && travelInsurance.ptiClient?travelInsurance.ptiClient.id:travelInsurance.insurer)
    :(travelInsurance&&travelInsurance.ptiClient ? travelInsurance.ptiClient.id:travelInsurance.insurer ? travelInsurance.insurer : null);
  }

  getReferenceDate(isFellowTraveller, travelInsurance){
    return !isFellowTraveller ? travelInsurance.ptiReferenceDate : travelInsurance.referenceDate ? travelInsurance.referenceDate : travelInsurance.ptiReferenceDate;
  }

  mapHealthInsurance(healthInsurance: HealthInsurance) {
    return !healthInsurance
      ? {}
      : {
        dossierId: healthInsurance.dossierId,
        id: isNaN(Number(healthInsurance.id)) ? healthInsurance.id : null,
        //parentOuId : healthInsurance.vhiInsurer ? healthInsurance.vhiInsurer.parentOuId : null,
        insurer: healthInsurance.vhiInsurer ? healthInsurance.vhiInsurer.shortName : null,
        insurerId: healthInsurance.vhiInsurer ? healthInsurance.vhiInsurer.id : null,
        alarmcenter: healthInsurance.vhiAlarmcenter,
        statusPolicyCheck: healthInsurance.vhiStatusPolisCheck ? healthInsurance.vhiStatusPolisCheck.toLowerCase() : null,
        typePolicyCheck: healthInsurance.vhiTypePolicyCheck,
        referenceDate: healthInsurance.vhiReferenceDate,
        isManual: healthInsurance.vhiIsManual,
        healthInsuranceNumber: healthInsurance.vhiHealthInsuranceNumber,
        insurerPhoneNumber: healthInsurance.vhiInsurerPhonenumber,
        comment: healthInsurance.vhiComments,
        bsn: healthInsurance.vhiBsn,
        policyType: healthInsurance.vhiPolicyType,
        productType: healthInsurance.vhiProductType,
        policyName: healthInsurance.vhiPolicyName,
        policyCode: healthInsurance.vhiPolicyCode,
        uzovi: healthInsurance.vhiUzovi,
        otherAlarmCenter: healthInsurance.vhiOtherAlarmCenter,
        datePolicyCheck: healthInsurance.vhiDatePolicyCheck,
        productId: healthInsurance.product && healthInsurance.product.productId?healthInsurance.product.productId:healthInsurance.vhiProductId,
        insuranceCoverageId : healthInsurance.vhiInsuranceCoverageId,
        personName: healthInsurance.vhiPersonName,
        feeServiceId:healthInsurance.vhiServiceFees,
        chargedExpensesId:healthInsurance.vhiChargedExpenses,
        alarmCenterId:healthInsurance.vhiMAlarmcenter,
        clientId:healthInsurance && healthInsurance.vhiClient?healthInsurance.vhiClient: healthInsurance.vhiInsurer ? healthInsurance.vhiInsurer.id : null,
        startDate: healthInsurance.vhiStartDate,
        endDate: healthInsurance.vhiEndDate
      };
  }

mapNoInsurancePolicy(noInsurancePolicy: NoInsurancePolicyModel) {
return !noInsurancePolicy
  ? {}
  : {
    nipId: noInsurancePolicy.nipId,
    nipAssociatedOuId : noInsurancePolicy.nipAssociatedOuId ? noInsurancePolicy.nipAssociatedOuId.id : null,
    nipIagPartnerCaseNumber:  noInsurancePolicy.nipIagPartnerCaseNumber,
    nipCoverageType:  noInsurancePolicy.nipCoverageType,
    nipPolicyCheckStatus:  noInsurancePolicy.nipPolicyCheckStatus,
    nipDossierId:  noInsurancePolicy.nipDossierId
  };
}

mapIntakeHelpPlans(helpPlan: HelpPlanDetailsModel) {
  let IshpdIdGuid = helpPlan.hpdId.toString().indexOf('-');
  let IsParenIdGuid = null;
  let TravelLegList: any = [];
  let concernedPersonList: any = [];
  let  proformaInvoiceList: any = [];
  let parentId = null;
  if (helpPlan.hpdHelpPlan.hplCode.trim() == 'AAN') {
    IsParenIdGuid = helpPlan.hdSpecific.tadLinkedHelpPlan.toString().indexOf('-');
    parentId = IsParenIdGuid != -1 ? helpPlan.hdSpecific.tadLinkedHelpPlan.toString() : null;
  }
  else if (helpPlan.hpdHelpPlan.hplCode.trim() == "AFV") {
    IsParenIdGuid = helpPlan.hdSpecific.tddLinkedHelpPlan.toString().indexOf('-');
    parentId = IsParenIdGuid != -1 ? helpPlan.hdSpecific.tddLinkedHelpPlan.toString() : null;
  }
  if (helpPlan.hpdHelpPlan.hplCode.trim() == 'OVG' || 
  helpPlan.hpdHelpPlan.hplCode.trim() == 'TOE'|| 
  helpPlan.hpdHelpPlan.hplCode.trim() == 'OVN'|| 
  helpPlan.hpdHelpPlan.hplCode.trim() == 'OSM'|| 
  helpPlan.hpdHelpPlan.hplCode.trim() == 'VVC') {
    if(helpPlan.hdSpecific.linkedHelpPlan != null){
      IsParenIdGuid = helpPlan.hdSpecific.linkedHelpPlan.toString().indexOf('-');
      parentId = IsParenIdGuid != -1 ? helpPlan.hdSpecific.linkedHelpPlan.toString() : null;
    }
  }
  else if (helpPlan.hpdHelpPlan.hplCode.trim() == "REI") {
    let TravelLegelement: any;
    helpPlan.travelLegList.forEach(tl => {
      TravelLegelement = this.mapTravelLeg(tl,helpPlan.dossierHelpPlanId);
       TravelLegList.push(TravelLegelement);
    });
  }
  if(helpPlan.hdSpecific.personConcerned){
    helpPlan.hdSpecific.personConcerned.forEach(pc => {
     if(pc != undefined){
      let newList={
        dhpId: helpPlan.dossierHelpPlanId,
        ipaId: pc.value} 
      concernedPersonList=[...concernedPersonList, newList]
     }
    });
  }
  if(helpPlan.hpdSupplierName!= null && helpPlan.hpdSupplier==null)
  {
    helpPlan.hpdSupplier=helpPlan.hpdSupplierName ;
  }
  if(helpPlan!= undefined){
    proformaInvoiceList = helpPlan.proformaInvoiceList;
 }
 if(helpPlan.hpdSupplierName!= null && !helpPlan.hpdSupplier)
  {
    helpPlan.hpdSupplier = helpPlan.hpdSupplierName ;
  }
  return !helpPlan
    ? {}
    : {
      hpdId: helpPlan.hpdId.toString(),
      dossierHelpPlanId: helpPlan.dossierHelpPlanId && IshpdIdGuid != -1 ? helpPlan.dossierHelpPlanId.toString() : null,
      ParentHelpPlanId: parentId,
      helpPlanTypeId: helpPlan.hpdHelpPlanType && helpPlan.hpdHelpPlanType.htyId ? helpPlan.hpdHelpPlanType.htyId : helpPlan.hpdHelpPlanType ? helpPlan.hpdHelpPlanType : null,
      helpPlanId: helpPlan.hpdHelpPlan.hplId ? helpPlan.hpdHelpPlan.hplId : helpPlan.hpdHelpPlan,
      supplierId: helpPlan.hpdSupplier ? helpPlan.hpdSupplier : null,
      phoneNumber: helpPlan.hpdPhoneNumber,
      fax: helpPlan.hpdFax,
      email: helpPlan.hpdEmail,
      travelLegs: TravelLegList ? TravelLegList : [],
      otdHealthInsuranceAlarmcenter:
        (helpPlan.hdSpecific &&
          helpPlan.hdSpecific.otdHealthInsuranceAlarmcenter)
          ? helpPlan.hdSpecific.otdHealthInsuranceAlarmcenter
          : null,
      otdTravelInsuranceAlarmcenter:
        (helpPlan.hdSpecific &&
          helpPlan.hdSpecific.otdTravelInsuranceAlarmcenter)
          ? helpPlan.hdSpecific.otdTravelInsuranceAlarmcenter
          : null,
      request:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.Request)
          ? helpPlan.hdSpecific.Request.id
          : null,
      otdDate:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.otdDate)
          ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.otdDate)
          : null,
      otdBsn:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.otdBSN)
          ? helpPlan.hdSpecific.otdBSN
          : null,
      otdIsTransferArrival:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.otdIsTransferArrival)
          ? helpPlan.hdSpecific.otdIsTransferArrival
          : null,
      otdIsTransferDeparture:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.otdIsTransferDeparture)
          ? helpPlan.hdSpecific.otdIsTransferDeparture
          : null,
      otdComment:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.otdComment)
          ? helpPlan.hdSpecific.otdComment
          : null,
      hdHealthInsuranceAlarmcenter:
        (helpPlan.hdSpecific &&
          helpPlan.hdSpecific.hdHealthInsuranceAlarmcenter)
          ? helpPlan.hdSpecific.hdHealthInsuranceAlarmcenter
          : null,
      hdTravelInsuranceAlarmcenter:
        (helpPlan.hdSpecific &&
          helpPlan.hdSpecific.hdTravelInsuranceAlarmcenter)
          ? helpPlan.hdSpecific.hdTravelInsuranceAlarmcenter
          : null,
      hdRequestFromDate:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdRequestFromDate)
        ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.hdRequestFromDate)
        : null,
      hdRequestToDate:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdRequestToDate)
          ?this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.hdRequestToDate)
          : null,
      hdIsDefinite:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdDefinite)
          ? helpPlan.hdSpecific.hdDefinite
          : null,
      hdIsIntensiveCare:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdIntensiveCare)
          ? helpPlan.hdSpecific.hdIntensiveCare
          : null,
      hdIntensiveCareFromDate:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdIntensiveCareFromDate)
        ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.hdIntensiveCareFromDate)
        : null,
      hdIntensiveCareToDate:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdIntensiveCareToDate)
          ? helpPlan.hdSpecific.hdIntensiveCareToDate
          : null,
      hdDepartment:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdDepartment)
          ? helpPlan.hdSpecific.hdDepartment
          : null,
      hdRoomNumber:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdRoomNumber)
          ? helpPlan.hdSpecific.hdRoomNumber
          : null,
      hdBsn:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdBSN)
          ? helpPlan.hdSpecific.hdBSN
          : null,
      hdDefinite:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdDefinite)
          ? helpPlan.hdSpecific.hdDefinite
          : null,
      hdIsTransferArrival:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdIsTransferArrival)
          ? helpPlan.hdSpecific.hdIsTransferArrival
          : null,
      hdIsTransferDeparture:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdIsTransferDeparture)
          ? helpPlan.hdSpecific.hdIsTransferDeparture
          : null,
      hdComment:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.hdComment)
          ? helpPlan.hdSpecific.hdComment
          : null,

      dhpPaymentType: (helpPlan.hdSpecific && helpPlan.hdSpecific.paymentType)
        ? helpPlan.hdSpecific.paymentType
        : null,
      dhpSosGuarantee: (helpPlan.hdSpecific && helpPlan.hdSpecific.sosGuarantee_sosEhic)
        ? helpPlan.hdSpecific.sosGuarantee_sosEhic
        : null,
      dhpContractedSupplier: (helpPlan.hdSpecific && helpPlan.hdSpecific.contractedSupplier && helpPlan.hdSpecific.contractedSupplier.value != 0 )
        ? helpPlan.hdSpecific.contractedSupplier.value
        : null,
      dhpOtherSubContractorId: (helpPlan.hdSpecific && helpPlan.hdSpecific.otherSupplier)
        ? helpPlan.hdSpecific.otherSupplier.value
        : null,
      dhpApprovedGuaranteeByMedicalUntil: (helpPlan.hdSpecific && helpPlan.hdSpecific.approvedGuaranteeByMedicalTeamUntil)
        ? helpPlan.hdSpecific.approvedGuaranteeByMedicalTeamUntil
        : null,
      dhpStatus: (helpPlan.hdSpecific && helpPlan.hdSpecific.status)
        ? helpPlan.hdSpecific.status.code
        : null,
      dhpClient: (helpPlan.hdSpecific && helpPlan.hdSpecific.client)
        ? helpPlan.hdSpecific.client.clientId
        : null,
      dhpProduct: (helpPlan.hdSpecific && helpPlan.hdSpecific.product)
        ? helpPlan.hdSpecific.product
        : null,
      dhpLuggage: (helpPlan.hdSpecific && helpPlan.hdSpecific.luggage)
        ? helpPlan.hdSpecific.luggage
        : null,
      dhpIsRepatriationMedicalUrgent: (helpPlan.hdSpecific && helpPlan.hdSpecific.repatMedicalUrgent)
        ? helpPlan.hdSpecific.repatMedicalUrgent
        : null,
      dhpTrasportationMode: (helpPlan.hdSpecific && helpPlan.hdSpecific.transportationMode)
        ? helpPlan.hdSpecific.transportationMode
        : null,
      dhpMedicalSupportNeeded: (helpPlan.hdSpecific && helpPlan.hdSpecific.medicalSupportNeeded)
        ? helpPlan.hdSpecific.medicalSupportNeeded
        : null,
      dhpMedicalApproval: (helpPlan.hdSpecific && helpPlan.hdSpecific.medicalApproval)
        ? helpPlan.hdSpecific.medicalApproval
        : null,
      dhpStretcher: (helpPlan.hdSpecific && helpPlan.hdSpecific.stretcher)
        ? helpPlan.hdSpecific.stretcher
        : null,
      dhpMeetAndAssist: (helpPlan.hdSpecific && helpPlan.hdSpecific.meetandAssist)
        ? helpPlan.hdSpecific.meetandAssist
        : null,
      dhpWheelchair: (helpPlan.hdSpecific && helpPlan.hdSpecific.wheelchair)
        ? helpPlan.hdSpecific.wheelchair
        : null,
      dhpOxygen: (helpPlan.hdSpecific && helpPlan.hdSpecific.oxygen)
        ? helpPlan.hdSpecific.oxygen
        : null,
      dhpLegrest: (helpPlan.hdSpecific && helpPlan.hdSpecific.legRest)
        ? helpPlan.hdSpecific.legRest
        : null,
      dhpAmountOfOxygen: (helpPlan.hdSpecific && helpPlan.hdSpecific.amountOfOxygen)
        ? helpPlan.hdSpecific.amountOfOxygen
        : null,
      tddLinkedHelpPlan: helpPlan.hdSpecific.tddLinkedHelpPlan && helpPlan.hdSpecific.tddLinkedHelpPlan != undefined ? helpPlan.hdSpecific.tddLinkedHelpPlan.toString() : null,

      tddDateTime:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tddDateTime)
          ? helpPlan.hdSpecific.tddDateTime
          : null,
      tddFrom:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tddFrom)
          ? helpPlan.hdSpecific.tddFrom
          : null,
      tddTo:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tddTo)
          ? helpPlan.hdSpecific.tddTo
          : null,
      tddTransportMode:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tddTransportMode)
          ? helpPlan.hdSpecific.tddTransportMode
          : null,
      tadLinkedHelpPlan: helpPlan.hdSpecific.tadLinkedHelpPlan && helpPlan.hdSpecific.tadLinkedHelpPlan != undefined ? helpPlan.hdSpecific.tadLinkedHelpPlan.toString() : null,
      tadDateTime:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tadDateTime)
          ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.tadDateTime)
          : null,
      tadFrom:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tadFrom)
          ? helpPlan.hdSpecific.tadFrom
          : null,
      tadTo:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tadTo)
          ? helpPlan.hdSpecific.tadTo
          : null,
      tadTransportMode:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tadTransportMode)
          ? helpPlan.hdSpecific.tadTransportMode
          : null,
      tdIsTravelneeded:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tdisTravelneeded)
          ? helpPlan.hdSpecific.tdisTravelneeded
          : null,
      tdIsTransferArrival:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tdisTransferArrival)
          ? helpPlan.hdSpecific.tdisTransferArrival
          : null,
      tdTransferArrivalComment:
        (helpPlan.hdSpecific &&
          helpPlan.hdSpecific.tdTransferArrivalComment)
          ? helpPlan.hdSpecific.tdTransferArrivalComment
          : null,
      tdIsTransferDeparture:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tdisTranferDeparture)
          ? helpPlan.hdSpecific.tdisTranferDeparture
          : null,
      tdTransferDepartureComment:
        (helpPlan.hdSpecific &&
          helpPlan.hdSpecific.tdTransferDepartureComment)
          ? helpPlan.hdSpecific.tdTransferDepartureComment
          : null,
      tdComment: (helpPlan.hdSpecific && helpPlan.hdSpecific.tdComment) ? helpPlan.hdSpecific.tdComment : null,
      repatMortalRemains:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.rmrRepatmortalremains)
          ? helpPlan.hdSpecific.rmrRepatmortalremains
          : null,
      rmrComment:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.rmrComment)
          ? helpPlan.hdSpecific.rmrComment
          : null,
      dhpDepartureCountry:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.departureCountry)
        ? helpPlan.hdSpecific.departureCountry.iso3Code
        : null,
      dhpDepartureLocation:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.departureLocation)
          ? helpPlan.hdSpecific.departureLocation
          : null,
      dhpDepartureAirport:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.departureAirport)
          ? helpPlan.hdSpecific.departureAirport.arpId
          : null,
      dhpDepartureDateTime:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.departureDateTime)
          ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.departureDateTime)
          : null,
      dhpArrivalLocation:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.arrivalLocation)
          ? helpPlan.hdSpecific.arrivalLocation
          : null,
      dhpArrivalCountry:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.arrivalCountry)
          ? helpPlan.hdSpecific.arrivalCountry.iso3Code
          : null,
      dhpArrivalAirport:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.arrivalAirport)
          ? helpPlan.hdSpecific.arrivalAirport.arpId
          : null,
      dhpArrivalDateTime:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.arrivalDateTime)
          ? helpPlan.hdSpecific.arrivalDateTime
          : null,
      dhpCarrier:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.carrier)
          ? helpPlan.hdSpecific.carrier
          : null,
      dhpFlightNumber:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.flightNumber)
          ? helpPlan.hdSpecific.flightNumber
          : null,
      dhpBookingNumber:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.bookingNumber)
          ? helpPlan.hdSpecific.bookingNumber
          : null,
      dhpComment:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.comment)
          ? helpPlan.hdSpecific.comment
          : null,
      dhpPayAttention:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.payAttention)
          ? helpPlan.hdSpecific.payAttention
          : null,
      dhpTarmacPermission:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.tarmacPermission)
          ? helpPlan.hdSpecific.tarmacPermission
          : null,
      dhpRequestedDate:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.requestedDate)
          ? helpPlan.hdSpecific.requestedDate
          : null,
      dhpReasonRequest:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.reasonRequest)
          ? helpPlan.hdSpecific.reasonRequest.toString()
          : null,
      dhpRequestType:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.requestType)
          ? helpPlan.hdSpecific.requestType
          : null,
      dhpOtherReasonRequest:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.otherReasonRequest)
          ? helpPlan.hdSpecific.otherReasonRequest
          : null,
       dhpRequestEscortType:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.requestEscortType && helpPlan.hdSpecific.requestEscortType.id)
          ? helpPlan.hdSpecific.requestEscortType.id.toString()
          : null,
      dhpDateFrom:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.dateFrom)
        ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.dateFrom) 
        : null,
      dhpDateTo:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.dateTo)
          ? helpPlan.hdSpecific.dateTo
          : null,
      dhpMeetingPoint:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.meetingPoint)
          ? helpPlan.hdSpecific.meetingPoint
          : null,
      dhpContactPersonName:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.contactPersonName)
          ? helpPlan.hdSpecific.contactPersonName
          : null,
      dhpContactPersonAddress:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.contactPersonAddress)
          ? helpPlan.hdSpecific.contactPersonAddress
          : null,
      dhpContactPersonPhonenumber:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.contactPersonPhonenumber)
          ? helpPlan.hdSpecific.contactPersonPhonenumber
          : null,
      dhpValueOfPackage:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.valueOfPackage)
          ? helpPlan.hdSpecific.valueOfPackage
          : null,
      dhpMedicationName:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.medicationName)
          ? helpPlan.hdSpecific.medicationName
          : null,
      dhpAmount:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.amount)
          ? helpPlan.hdSpecific.amount
          : null,
      dhpContent:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.content)
          ? helpPlan.hdSpecific.content
          : null,
      dhpSpecialNeedsForTransport:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.specialNeedsForTransport)
          ? helpPlan.hdSpecific.specialNeedsForTransport
          : null,
      dhpTotalCosts:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.totalCosts)
          ? helpPlan.hdSpecific.totalCosts
          : null,
      dhpToWhomAgreed:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.toWhomAgreed)
          ? helpPlan.hdSpecific.toWhomAgreed
          : null,
      dhpKindOfCosts:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.kindOfCosts)
          ? helpPlan.hdSpecific.kindOfCosts
          : null,
      dhpResidenceName:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.residenceName)
          ? helpPlan.hdSpecific.residenceName
          : null,
      dhpResidenceAddress:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.residenceAddress)
          ? helpPlan.hdSpecific.residenceAddress
          : null,
      dhpResidencePhoneNumber:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.residencePhoneNumber)
          ? helpPlan.hdSpecific.residencePhoneNumber
          : null,
      dhpCheckoutDate:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.checkOutDate)
          ? helpPlan.hdSpecific.checkOutDate
          : null,
      dhpAmountOfNights:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.amountOfNights)
          ? helpPlan.hdSpecific.amountOfNights.toString()
          : null,
      dhpTypeOfRoom:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.typeOfRoom)
          ? helpPlan.hdSpecific.typeOfRoom
          : null,
      dhpOtherCostType:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.otherCostType)
          ? helpPlan.hdSpecific.otherCostType
          : null,
      dhpChauffeurName:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.chauffeurName)
          ? helpPlan.hdSpecific.chauffeurName
          : null,
      dhpChauffeurTelephone:
          (helpPlan.hdSpecific && helpPlan.hdSpecific.chauffeurTelephone)
            ? helpPlan.hdSpecific.chauffeurTelephone
            : null,
      dhpCarLocation:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.carLocation)
          ? helpPlan.hdSpecific.carLocation
          : null,
      dhpDropOffLocation:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.dropOffLocation)
          ? helpPlan.hdSpecific.dropOffLocation
          : null,
      dhpDateTime:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.dropOffDate)
          ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.dropOffDate)
          : null,
      dhpLinkedHelpPlan: 
      helpPlan.hdSpecific.linkedHelpPlan && helpPlan.hdSpecific.linkedHelpPlan != undefined 
      ? helpPlan.hdSpecific.linkedHelpPlan.toString() 
      : null,
      concernedPersonHelpPlans: concernedPersonList ? concernedPersonList : [],
      workingOrderLines : proformaInvoiceList
    };
}

mapUpdateHelpPlans(helpPlan: HelpPlanDetailsModel) {
let IshpdIdGuid = helpPlan.hpdId.toString().indexOf('-');
let IsParenIdGuid = null;
let TravelLegList: any = [];
let concernedPersonList: any = [];
let  proformaInvoiceList: any = [];
let parentId = null;
if (helpPlan.hpdHelpPlan.hplCode.trim() == 'AAN') {
  IsParenIdGuid = helpPlan.hdSpecific.tadLinkedHelpPlan.toString().indexOf('-');
  parentId = IsParenIdGuid != -1 ? helpPlan.hdSpecific.tadLinkedHelpPlan.toString() : null;
}
else if (helpPlan.hpdHelpPlan.hplCode.trim() == "AFV") {
  IsParenIdGuid = helpPlan.hdSpecific.tddLinkedHelpPlan.toString().indexOf('-');
  parentId = IsParenIdGuid != -1 ? helpPlan.hdSpecific.tddLinkedHelpPlan.toString() : null;
}
if (helpPlan.hpdHelpPlan.hplCode.trim() == 'OVG' || 
helpPlan.hpdHelpPlan.hplCode.trim() == 'TOE'|| 
helpPlan.hpdHelpPlan.hplCode.trim() == 'OVN'|| 
helpPlan.hpdHelpPlan.hplCode.trim() == 'OSM'|| 
helpPlan.hpdHelpPlan.hplCode.trim() == 'VVC') {
  if(helpPlan.hdSpecific.linkedHelpPlan != null){
    IsParenIdGuid = helpPlan.hdSpecific.linkedHelpPlan.toString().indexOf('-');
    parentId = IsParenIdGuid != -1 ? helpPlan.hdSpecific.linkedHelpPlan.toString() : null;
  }
}
else if (helpPlan.hpdHelpPlan.hplCode.trim() == "REI") {
  let TravelLegelement: any;
  helpPlan.travelLegList.forEach(tl => {
    TravelLegelement = this.mapTravelLeg(tl,helpPlan.dossierHelpPlanId);
     TravelLegList.push(TravelLegelement);
  });
}
if(helpPlan.hdSpecific.personConcerned){
  helpPlan.hdSpecific.personConcerned.forEach(pc => {
   if(pc != undefined){
    let newList={
      dhpId: helpPlan.dossierHelpPlanId,
      ipaId: pc.value,
    } 
    concernedPersonList=[...concernedPersonList, newList]
   }
  });
}
if(helpPlan.hpdSupplierName!= null && helpPlan.hpdSupplier==null)
{
  helpPlan.hpdSupplier=helpPlan.hpdSupplierName ;
}
if(helpPlan!= undefined){
  proformaInvoiceList = helpPlan.proformaInvoiceList;
}
if(helpPlan.hpdSupplierName!= null && !helpPlan.hpdSupplier)
{
  helpPlan.hpdSupplier = helpPlan.hpdSupplierName ;
}
return !helpPlan
  ? {}
  : {
    dhpId: helpPlan.dossierHelpPlanId?helpPlan.hpdId.toString():null,
    dossierHelpPlanId: helpPlan.dossierHelpPlanId && IshpdIdGuid != -1 ? helpPlan.dossierHelpPlanId.toString() : null,
    ParentHelpPlanId: parentId,
    dhpHelpPlanTypeId: helpPlan.hpdHelpPlanType && helpPlan.hpdHelpPlanType.htyId ? helpPlan.hpdHelpPlanType.htyId : helpPlan.hpdHelpPlanType ? helpPlan.hpdHelpPlanType : null,
    dhpHelpPlanId: helpPlan.hpdHelpPlan.hplId ? helpPlan.hpdHelpPlan.hplId : helpPlan.hpdHelpPlan,
    dhpSupplierId: helpPlan.hpdSupplier ? helpPlan.hpdSupplier : null,
    dhpPhoneNumber: helpPlan.hpdPhoneNumber,
    dhpFax: helpPlan.hpdFax,
    dhpEmail: helpPlan.hpdEmail,
    travelLegs: TravelLegList ? TravelLegList : [],
    selectedTravelLegId : helpPlan.selectedTravelLegId,
    dhpOtdHealthInsuranceAlarmcenter:
      (helpPlan.hdSpecific &&
        helpPlan.hdSpecific.otdHealthInsuranceAlarmcenter)
        ? helpPlan.hdSpecific.otdHealthInsuranceAlarmcenter
        : null,
    dhpOtdTravelInsuranceAlarmcenter:
      (helpPlan.hdSpecific &&
        helpPlan.hdSpecific.otdTravelInsuranceAlarmcenter)
        ? helpPlan.hdSpecific.otdTravelInsuranceAlarmcenter
        : null,
    dhprequest:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.Request)
        ? helpPlan.hdSpecific.Request.id
        : null,
    dhpOtdDate:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.otdDate)
        ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.otdDate)
        : null,
    dhpOtdBsn:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.otdBSN)
        ? helpPlan.hdSpecific.otdBSN
        : null,
    dhpOtdIsTransferArrival:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.otdIsTransferArrival)
        ? helpPlan.hdSpecific.otdIsTransferArrival
        : null,
    dhpOtdIsTransferDeparture:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.otdIsTransferDeparture)
        ? helpPlan.hdSpecific.otdIsTransferDeparture
        : null,
    dhpOtdComment:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.otdComment)
        ? helpPlan.hdSpecific.otdComment
        : null,
    dhpHdHealthInsuranceAlarmcenter:
      (helpPlan.hdSpecific &&
        helpPlan.hdSpecific.hdHealthInsuranceAlarmcenter)
        ? helpPlan.hdSpecific.hdHealthInsuranceAlarmcenter
        : null,
    dhpHdTravelInsuranceAlarmcenter:
      (helpPlan.hdSpecific &&
        helpPlan.hdSpecific.hdTravelInsuranceAlarmcenter)
        ? helpPlan.hdSpecific.hdTravelInsuranceAlarmcenter
        : null,
    dhpHdRequestFromDate:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdRequestFromDate)
      ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.hdRequestFromDate) 
      : null,
    dhpHdRequestToDate:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdRequestToDate)
        ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.hdRequestToDate)
        : null,
    dhpHdIsDefinite:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdDefinite)
        ? helpPlan.hdSpecific.hdDefinite
        : null,
    dhpHdIsIntensiveCare:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdIntensiveCare)
        ? helpPlan.hdSpecific.hdIntensiveCare
        : null,
    dhpHdIntensiveCareFromDate:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdIntensiveCareFromDate)
      ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.hdIntensiveCareFromDate)
      : null,
    dhpHdIntensiveCareToDate:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdIntensiveCareToDate)
        ? helpPlan.hdSpecific.hdIntensiveCareToDate
        : null,
    dhpHdDepartment:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdDepartment)
        ? helpPlan.hdSpecific.hdDepartment
        : null,
    dhpHdRoomNumber:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdRoomNumber)
        ? helpPlan.hdSpecific.hdRoomNumber
        : null,
    dhpHdBsn:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdBSN)
        ? helpPlan.hdSpecific.hdBSN
        : null,
    dhpHdDefinite:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdDefinite)
        ? helpPlan.hdSpecific.hdDefinite
        : null,
    dhpHdIsTransferArrival:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdIsTransferArrival)
        ? helpPlan.hdSpecific.hdIsTransferArrival
        : null,
    dhpHdIsTransferDeparture:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdIsTransferDeparture)
        ? helpPlan.hdSpecific.hdIsTransferDeparture
        : null,
    dhpHdComment:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.hdComment)
        ? helpPlan.hdSpecific.hdComment
        : null,

    dhpPaymentType: (helpPlan.hdSpecific && helpPlan.hdSpecific.paymentType)
      ? helpPlan.hdSpecific.paymentType
      : null,
    dhpSosGuarantee: (helpPlan.hdSpecific && helpPlan.hdSpecific.sosGuarantee_sosEhic)
      ? helpPlan.hdSpecific.sosGuarantee_sosEhic
      : null,
    dhpContractedSupplier: (helpPlan.hdSpecific && helpPlan.hdSpecific.contractedSupplier && helpPlan.hdSpecific.contractedSupplier.value != 0 )
      ? helpPlan.hdSpecific.contractedSupplier.value
      : null,
    dhpOtherSubContractorId: (helpPlan.hdSpecific && helpPlan.hdSpecific.otherSupplier)
      ? helpPlan.hdSpecific.otherSupplier.value
      : null,
    dhpApprovedGuaranteeByMedicalUntil: (helpPlan.hdSpecific && helpPlan.hdSpecific.approvedGuaranteeByMedicalTeamUntil)
      ? helpPlan.hdSpecific.approvedGuaranteeByMedicalTeamUntil
      : null,
    dhpStatus: (helpPlan.hdSpecific && helpPlan.hdSpecific.status)
      ? helpPlan.hdSpecific.status.code
      : null,
    dhpClient: (helpPlan.hdSpecific && helpPlan.hdSpecific.client)
      ? helpPlan.hdSpecific.client.clientId
      : null,
    dhpProduct: (helpPlan.hdSpecific && helpPlan.hdSpecific.client)
      ? helpPlan.hdSpecific.client.productId
      : null,
    dhpLuggage: (helpPlan.hdSpecific && helpPlan.hdSpecific.luggage)
      ? helpPlan.hdSpecific.luggage
      : null,
    dhpIsRepatriationMedicalUrgent: (helpPlan.hdSpecific && helpPlan.hdSpecific.repatMedicalUrgent)
      ? helpPlan.hdSpecific.repatMedicalUrgent
      : null,
    dhpTrasportationMode: (helpPlan.hdSpecific && helpPlan.hdSpecific.transportationMode)
      ? helpPlan.hdSpecific.transportationMode
      : null,
    dhpMedicalSupportNeeded: (helpPlan.hdSpecific && helpPlan.hdSpecific.medicalSupportNeeded)
      ? helpPlan.hdSpecific.medicalSupportNeeded
      : null,
    dhpMedicalApproval: (helpPlan.hdSpecific && helpPlan.hdSpecific.medicalApproval)
      ? helpPlan.hdSpecific.medicalApproval
      : null,
    dhpStretcher: (helpPlan.hdSpecific && helpPlan.hdSpecific.stretcher)
      ? helpPlan.hdSpecific.stretcher
      : null,
    dhpMeetAndAssist: (helpPlan.hdSpecific && helpPlan.hdSpecific.meetandAssist)
      ? helpPlan.hdSpecific.meetandAssist
      : null,
    dhpWheelchair: (helpPlan.hdSpecific && helpPlan.hdSpecific.wheelchair)
      ? helpPlan.hdSpecific.wheelchair
      : null,
    dhpOxygen: (helpPlan.hdSpecific && helpPlan.hdSpecific.oxygen)
      ? helpPlan.hdSpecific.oxygen
      : null,
    dhpLegrest: (helpPlan.hdSpecific && helpPlan.hdSpecific.legRest)
      ? helpPlan.hdSpecific.legRest
      : null,
    dhpAmountOfOxygen: (helpPlan.hdSpecific && helpPlan.hdSpecific.amountOfOxygen)
      ? helpPlan.hdSpecific.amountOfOxygen
      : null,
    dhpTddLinkedHelpPlan: helpPlan.hdSpecific.tddLinkedHelpPlan && helpPlan.hdSpecific.tddLinkedHelpPlan != undefined ? helpPlan.hdSpecific.tddLinkedHelpPlan.toString() : null,

    dhpTddDateTime:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tddDateTime)
        ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.tddDateTime)
        : null,
    dhpTddFrom:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tddFrom)
        ? helpPlan.hdSpecific.tddFrom
        : null,
    dhpTddTo:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tddTo)
        ? helpPlan.hdSpecific.tddTo
        : null,
    dhpTddTransportMode:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tddTransportMode)
        ? helpPlan.hdSpecific.tddTransportMode
        : null,
    dhpTadLinkedHelpPlan: helpPlan.hdSpecific.tadLinkedHelpPlan && helpPlan.hdSpecific.tadLinkedHelpPlan != undefined ? helpPlan.hdSpecific.tadLinkedHelpPlan.toString() : null,
    dhpTadDateTime:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tadDateTime)
        ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.tadDateTime)
        : null,
    dhpTadFrom:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tadFrom)
        ? helpPlan.hdSpecific.tadFrom
        : null,
    dhpTadTo:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tadTo)
        ? helpPlan.hdSpecific.tadTo
        : null,
    dhpTadTransportMode:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tadTransportMode)
        ? helpPlan.hdSpecific.tadTransportMode
        : null,
    dhpTdIsTravelneeded:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tdisTravelneeded)
        ? helpPlan.hdSpecific.tdisTravelneeded
        : null,
    dhpTdIsTransferArrival:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tdisTransferArrival)
        ? helpPlan.hdSpecific.tdisTransferArrival
        : null,
    dhpTdTransferArrivalComment:
      (helpPlan.hdSpecific &&
        helpPlan.hdSpecific.tdTransferArrivalComment)
        ? helpPlan.hdSpecific.tdTransferArrivalComment
        : null,
    dhpTdIsTransferDeparture:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tdisTranferDeparture)
        ? helpPlan.hdSpecific.tdisTranferDeparture
        : null,
    dhpTdTransferDepartureComment:
      (helpPlan.hdSpecific &&
        helpPlan.hdSpecific.tdTransferDepartureComment)
        ? helpPlan.hdSpecific.tdTransferDepartureComment
        : null,
    dhpTdComment: (helpPlan.hdSpecific && helpPlan.hdSpecific.tdComment) ? helpPlan.hdSpecific.tdComment : null,
    repatMortalRemains:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.rmrRepatmortalremains)
        ? helpPlan.hdSpecific.rmrRepatmortalremains
        : null,
    dhpRmrComment:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.rmrComment)
        ? helpPlan.hdSpecific.rmrComment
        : null,
    dhpDepartureCountry:
    (helpPlan.hdSpecific && helpPlan.hdSpecific.departureCountry)
      ? helpPlan.hdSpecific.departureCountry.iso3Code
      : null,
    dhpDepartureLocation:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.departureLocation)
        ? helpPlan.hdSpecific.departureLocation
        : null,
    dhpDepartureAirport:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.departureAirport)
        ? helpPlan.hdSpecific.departureAirport.arpId
        : null,
    dhpDepartureDateTime:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.departureDateTime)
        ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.departureDateTime)

        : null,
    dhpArrivalLocation:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.arrivalLocation)
        ? helpPlan.hdSpecific.arrivalLocation
        : null,
    dhpArrivalCountry:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.arrivalCountry)
        ? helpPlan.hdSpecific.arrivalCountry.iso3Code
        : null,
    dhpArrivalAirport:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.arrivalAirport)
        ? helpPlan.hdSpecific.arrivalAirport.arpId
        : null,
    dhpArrivalDateTime:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.arrivalDateTime)
        ? helpPlan.hdSpecific.arrivalDateTime
        : null,
    dhpCarrier:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.carrier)
        ? helpPlan.hdSpecific.carrier
        : null,
    dhpFlightNumber:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.flightNumber)
        ? helpPlan.hdSpecific.flightNumber
        : null,
    dhpBookingNumber:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.bookingNumber)
        ? helpPlan.hdSpecific.bookingNumber
        : null,
    dhpComment:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.comment)
        ? helpPlan.hdSpecific.comment
        : null,
    dhpPayAttention:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.payAttention)
        ? helpPlan.hdSpecific.payAttention
        : null,
    dhpTarmacPermission:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.tarmacPermission)
        ? helpPlan.hdSpecific.tarmacPermission
        : null,
    dhpRequestedDate:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.requestedDate)
        ? helpPlan.hdSpecific.requestedDate
        : null,
    dhpReasonRequest:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.reasonRequest)
        ? helpPlan.hdSpecific.reasonRequest.toString()
        : null,
    dhpRequestType:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.requestType)
        ? helpPlan.hdSpecific.requestType
        : null,
    dhpOtherReasonRequest:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.otherReasonRequest)
        ? helpPlan.hdSpecific.otherReasonRequest
        : null,
     dhpRequestEscortType:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.requestEscortType && helpPlan.hdSpecific.requestEscortType.id)
        ? helpPlan.hdSpecific.requestEscortType.id.toString()
        : null,
    dhpDateFrom:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.dateFrom)
      ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.dateFrom)
      : null,
    dhpDateTo:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.dateTo)
        ? helpPlan.hdSpecific.dateTo
        : null,
    dhpMeetingPoint:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.meetingPoint)
        ? helpPlan.hdSpecific.meetingPoint
        : null,
    dhpContactPersonName:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.contactPersonName)
        ? helpPlan.hdSpecific.contactPersonName
        : null,
    dhpContactPersonAddress:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.contactPersonAddress)
        ? helpPlan.hdSpecific.contactPersonAddress
        : null,
    dhpContactPersonPhonenumber:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.contactPersonPhonenumber)
        ? helpPlan.hdSpecific.contactPersonPhonenumber
        : null,
    dhpValueOfPackage:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.valueOfPackage)
        ? helpPlan.hdSpecific.valueOfPackage
        : null,
    dhpMedicationName:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.medicationName)
        ? helpPlan.hdSpecific.medicationName
        : null,
    dhpAmount:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.amount)
        ? helpPlan.hdSpecific.amount
        : null,
    dhpContent:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.content)
        ? helpPlan.hdSpecific.content
        : null,
    dhpSpecialNeedsForTransport:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.specialNeedsForTransport)
        ? helpPlan.hdSpecific.specialNeedsForTransport
        : null,
    dhpTotalCosts:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.totalCosts)
        ? helpPlan.hdSpecific.totalCosts
        : null,
    dhpToWhomAgreed:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.toWhomAgreed)
        ? helpPlan.hdSpecific.toWhomAgreed
        : null,
    dhpKindOfCosts:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.kindOfCosts)
        ? helpPlan.hdSpecific.kindOfCosts
        : null,
    dhpResidenceName:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.residenceName)
        ? helpPlan.hdSpecific.residenceName
        : null,
    dhpResidenceAddress:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.residenceAddress)
        ? helpPlan.hdSpecific.residenceAddress
        : null,
    dhpResidencePhoneNumber:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.residencePhoneNumber)
        ? helpPlan.hdSpecific.residencePhoneNumber
        : null,
    dhpCheckoutDate:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.checkOutDate)
        ? helpPlan.hdSpecific.checkOutDate
        : null,
    dhpAmountOfNights:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.amountOfNights)
        ? helpPlan.hdSpecific.amountOfNights.toString()
        : null,
    dhpTypeOfRoom:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.typeOfRoom)
        ? helpPlan.hdSpecific.typeOfRoom
        : null,
    dhpOtherCostType:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.otherCostType)
        ? helpPlan.hdSpecific.otherCostType
        : null,
    dhpChauffeurName:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.chauffeurName)
        ? helpPlan.hdSpecific.chauffeurName
        : null,
    dhpChauffeurTelephone:
        (helpPlan.hdSpecific && helpPlan.hdSpecific.chauffeurTelephone)
          ? helpPlan.hdSpecific.chauffeurTelephone
          : null,
    dhpCarLocation:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.carLocation)
        ? helpPlan.hdSpecific.carLocation
        : null,
    dhpDropOffLocation:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.dropOffLocation)
        ? helpPlan.hdSpecific.dropOffLocation
        : null,
    dhpDateTime:
      (helpPlan.hdSpecific && helpPlan.hdSpecific.dropOffDate)
        ? this.dateService.getLocalISODateFormat(helpPlan.hdSpecific.dropOffDate)
        : null,
    dhpLinkedHelpPlan: 
    helpPlan.hdSpecific.linkedHelpPlan && helpPlan.hdSpecific.linkedHelpPlan != undefined 
    ? helpPlan.hdSpecific.linkedHelpPlan.toString() 
    : null,
    concernedPersonHelpPlans: concernedPersonList ? concernedPersonList : [],
    workingOrderLines : proformaInvoiceList
  };
}

mapTravelLeg(travelLeg: TravelLegModel,helpPlan:string) {
let concernedPersonList =[];
if(travelLeg.concernedPersonHelpPlans){
  travelLeg.concernedPersonHelpPlans.forEach(pc => {
   if(pc != undefined){
    let newList={
      dhpId: helpPlan,
      ipaId: pc.ipaId,
      chpId: pc.chpId
    } 
    concernedPersonList=[...concernedPersonList, newList]
   }
  });
}
return {
  tlId: travelLeg.tlId ? travelLeg.tlId : null,
  tlDossierHelpPlanId: helpPlan?helpPlan : null,
  tlDepartureDate: this.dateService.getLocalISODateFormat(travelLeg.tlDepartureDate),
  tlArrivalDate: this.dateService.getLocalISODateFormat(travelLeg.tlArrivalDate),
  tlFromCountry: travelLeg.tlFromCountry ? travelLeg.tlFromCountry.id : null ,
  tlToCountry: travelLeg.tlToCountry? travelLeg.tlToCountry.id : null,
  tlFromAirport: travelLeg.tlFromAirport ? travelLeg.tlFromAirport.arpId : null,
  tlToAirport: travelLeg.tlToAirport ? travelLeg.tlToAirport.arpId : null,
  tlFromStation: travelLeg.tlFromStation ? travelLeg.tlFromStation : null,
  tlToStation: travelLeg.tlToStation ? travelLeg.tlToStation : null,
  tlFromLocation: travelLeg.tlFromLocation ? travelLeg.tlFromLocation : null,
  tlToLocation: travelLeg.tlToLocation ? travelLeg.tlToLocation : null,
  tlAirline: travelLeg.tlAirline ? travelLeg.tlAirline.airId : null,
  tlFlightNumber: travelLeg.tlFlightNumber ? travelLeg.tlFlightNumber : null,
  tlTrainNumber: travelLeg.tlTrainNumber ? travelLeg.tlTrainNumber : null,
  tlComment: travelLeg.tlComment ? travelLeg.tlComment : null,
  tlTransportMode : travelLeg.tlTransportMode ? travelLeg.tlTransportMode : null ,
  tlIsRepatriationMedicalUrgent:travelLeg.tlIsRepatriationMedicalUrgent ? travelLeg.tlIsRepatriationMedicalUrgent : null ,
  tlMedicalSupportNeeded:travelLeg.tlMedicalSupportNeeded ? travelLeg.tlMedicalSupportNeeded : null ,
  tlMedicalApproval : travelLeg.tlMedicalApproval ? travelLeg.tlMedicalApproval : null,
  tlLegrest : travelLeg.tlLegrest ? travelLeg.tlLegrest : null,
  tlStretcher: travelLeg.tlStretcher ? travelLeg.tlStretcher : null,
  tlMeetAndAssist: travelLeg.tlMeetAndAssist ? travelLeg.tlMeetAndAssist : null,
  tlWheelchair: travelLeg.tlWheelchair ? travelLeg.tlWheelchair : null,
  tlOxygen: travelLeg.tlOxygen ? travelLeg.tlOxygen : null,
  tlAmountOfOxygen: travelLeg.tlAmountOfOxygen ? travelLeg.tlAmountOfOxygen : null,
  tlLuggage: travelLeg.tlLuggage ? travelLeg.tlLuggage : null ,
  tlFromCity: travelLeg.tlFromCity ? travelLeg.tlFromCity : null ,
  tlToCity: travelLeg.tlToCity ? travelLeg.tlToCity : null ,
  tlFromIataCode: travelLeg.tlFromIataCode ? travelLeg.tlFromIataCode : null ,
  tlToIataCode: travelLeg.tlToIataCode ? travelLeg.tlToIataCode : null ,
  tlPta: (travelLeg.tlPta != null) ? travelLeg.tlPta : null ,
  tlTarmac: (travelLeg.tlTarmac != null)? travelLeg.tlTarmac : null ,
  tlPnr: travelLeg.tlPnr ? travelLeg.tlPnr : null ,
  tlClass: travelLeg.tlClass ? travelLeg.tlClass : null ,
  concernedPersonHelpPlans : concernedPersonList
}
}
mapContactPerson(contactPerson: ContactPerson) {
return {
  relationshipId: (contactPerson.cpeRelationship && contactPerson.cpeRelationship.prId) ? contactPerson.cpeRelationship.prId : null,
  genderId: contactPerson.cpeGender != null ? contactPerson.cpeGender : null,
  countryId: (contactPerson.cpeCountry && contactPerson.cpeCountry.id) ? contactPerson.cpeCountry.id : null,
  firstName: contactPerson.cpeFirstName,
  lastName: contactPerson.cpeLastName,
  maidenName: contactPerson.cpeMaidenName,
  phoneNumber:
    (contactPerson.cpePhoneNumber && contactPerson.cpePhoneNumber.toString())
      ? contactPerson.cpePhoneNumber.toString()
      : null,
  email: contactPerson.cpeEmail,
  address: contactPerson.cpeAddress,
  city: contactPerson.cpeCity,
  sharePrivateInformation : contactPerson.cpeSharePrivateInformation,
  remarks: contactPerson.cpeRemarks,
};
}

mapCoroners(coroner: CoronerModel) {
return {
  name: coroner.corName,
  streetName: coroner.corStreetName,
  houseNumber: coroner.corHouseNumber,
  houseNumberAddition: coroner.corHouseNumberAddition,
  postalCode: coroner.corPostalCode,
  city: coroner.corCity,
  countryId: coroner.corCountry ? coroner.corCountry.id : null,
  phoneNumber:
    (coroner.corPhoneNumber && coroner.corPhoneNumber.toString())
      ? coroner.corPhoneNumber.toString()
      : null,
  contactPerson: coroner.corContactPerson,
};
}

mapLocationUpdate(location: LocationDetailsModel) {
return !location
  ? {}
  : {
    address1: location.ldAddress1,
    address2:
      (location.ldAddress2 &&
        location.ldAddress2.toString())
        ? location.ldAddress2
        : null,
    longitude: location.ldLongitude ? location.ldLongitude.toString() : null,
    latitude: location.ldLatitude ? location.ldLatitude.toString() : null,
    postalCode: location.ldPostalCode,
    supplierId: location.ldSupplierId,
    city: location.ldCity,
    country: (location.ldCountry && location.ldCountry.id)
      ? { id: location.ldCountry.id, name: location.ldCountry.name } : null,
    telephone: location.ldTelephone,
    comment: location.ldComment,
    locationTypeId: location.ldLocationTypeId,
    locationName:
      (location.ldLocationName &&
        location.ldLocationName.toString())
        ? location.ldLocationName
        : null,
  
  };
}

mapLocationPost(location: LocationDetailsModel,lctId:string) {
return !location
  ? {}
  : {
    address1: location.ldAddress1,
    address2:
      (location.ldAddress2 &&
        location.ldAddress2.toString())
        ? location.ldAddress2
        : null,
    longitude: location.ldLongitude ? location.ldLongitude.toString() : null,
    latitude: location.ldLatitude ? location.ldLatitude.toString() : null,
    postalCode: location.ldPostalCode,
    supplierId:location.ldSupplierId ? location.ldSupplierId : null,
    city: location.ldCity,
    country: (location.ldCountry)
    ? location.ldCountry : null,
    telephone: location.ldTelephone,
    comment: location.ldComment,
    locationTypeId: location.ldLocationTypeId ? lctId.toString() : null,
    locationName:
    (location.ldLocationName &&
      location.ldLocationName.toString())
      ? location.ldLocationName
      : null,
  };
}

fillIntakeDataPost(intake: IntakeDataModel) {
return {
  originalDossierId : intake.originalDossierId,
  userName: this.authenticationService.currentUserValue.name, 
  userEmail: this.authenticationService.currentUserValue.unique_name,
  dossierId: intake.dossierId,
  draftDossierNumber : intake.draftDossierNumber,
  dossierNumber: intake.policy.dossierNbr,
  intakeDuration: intake.intakeDuration,
  comments: intake.summary.comment,
  agreements: intake.summary.agreement,
  dossierStatus: intake.dossierStatus,
  isUrgent: intake.isUrgent,
  coverage:intake.summary.coverage,
  linkedDossiers: intake.linkedDossiers,
  insuree: {
    bsn: intake.insuree.ipaBsnCitizenServiceNumber,
    initials: intake.insuree.ipaInitials,
    firstName: intake.insuree.ipaFirstName,
    lastName: intake.insuree.ipaLastName,
    maidenName: intake.insuree.ipaMaidenName,
    streetName: intake.insuree.ipaStreetName,
    houseNumber: intake.insuree.ipaHouseNumber,
    houseNumberAddition: intake.insuree.ipaHouseNumberAddition,
    postalCode: intake.insuree.ipaPostalCode,
    city: intake.insuree.ipaCity,
    countryId: intake.insuree.country.id,
    phoneNumber: intake.insuree.ipaPhoneNumber ? intake.insuree.ipaPhoneNumber.toString() : null,
    phoneNumber2:
      intake.insuree.ipaPhoneNumber2 ? intake.insuree.ipaPhoneNumber2.toString() : null,
    email: intake.insuree.ipaEmail,
    dateOfBirth: this.dateService.getLocalISODateFormat(intake.insuree.ipaDateOfBirth),
    gender: intake.insuree.ipaPartyGender ? intake.insuree.ipaPartyGender : null,
    remarks: intake.insuree.ipaRemarks,
    contactInitiationId: intake.insuree.ipaContactInitiation,
    contactWithId: intake.insuree.ipaContactWith,
    contactInitiationPhone: intake.insuree.ipaContactTelephone ? intake.insuree.ipaContactTelephone : null,
    contactEmail: intake.insuree.ipaContactEmail,
    contactComment: intake.insuree.ipaContactComment,
    sharePrivateInformation: intake.insuree.ipaSharePrivateInformation,
    contactPersons: [],
  },
  policy: {
    caseTypeId: intake.policy.cause.ctyId,
    dossierAssignmentTypeId : intake.policy.cause.ctyDossierAssignmentTypeId,
        dossierProductId : intake.policy.cause.ctyDossierProductId,
        clientId: intake.policy.client ? intake.policy.client.id : null,
        isOwnCost: intake.policy.isNoPolicycheck,
        accidentLocation: intake.policy.location,
        countryId: intake.policy.country.id,
        reason: intake.policy.reason,
        calamityId :intake.policy.selectedCalamities? intake.policy.selectedCalamities.calId:null,
        iagPartnerCaseNumber: intake.policy.iagPartnerCaseNumber,
        iagPartnerId: intake.policy.iagCorePartner ? intake.policy.iagCorePartner.id : null,
        nedherlandAlaId: intake.policy.nedherlandAla ? intake.policy.nedherlandAla.id : null,
        incidentDate: this.dateService.getLocalISODateFormat(intake.policy.incidentDate),
        travelInsurancePolicies: [],
        healthInsurancePolicies: [],
        noInsurancePolicies: [],
        personalInfo : intake.policy.personalInformations
      },
      caseDetail:intake.case == null?null: {
        deathDetail: intake.case.death == null
          ? null
          : {
            dateOfDeath: intake.case.death.dthDateOfDeath
              ? this.dateService.getLocalISODateFormat(intake.case.death.dthDateOfDeath)
              : null,
            causeOfDeath: (intake.case.death.dthCauseOfDeath != null)
              ? intake.case.death.dthCauseOfDeath
              : null,
            isAutopsy:
              (intake.case.death.dthIsAutopy != null)
                ? intake.case.death.dthIsAutopy
                : null,
            isPoliceInvolved:
              (intake.case.death.dthIsPoliceInvolved != null)
                ? intake.case.death.dthIsPoliceInvolved
                : null,
            description: intake.case.death.dthDescription,
            dutchCoroner: intake.case.death.dutchCoroner ? this.mapCoroners(intake.case.death.dutchCoroner) : null,
            foreignCoroner: intake.case.death.foreignCorner ? this.mapCoroners(
              intake.case.death.foreignCorner
            ) : null,
            dpiFirstName: intake.case.death.deadPerson.dpFirstName,
            dpiLastName: intake.case.death.deadPerson.dpLastName,
            dpiPostalCode: intake.case.death.deadPerson.dpPostalCode,
            dpiHouseNumber: intake.case.death.deadPerson.dpHouseNumber,
            dpiHouseNumberAddition: intake.case.death.deadPerson.dpHouseNumberAddition,
            dpiStreetName: intake.case.death.deadPerson.dpStreetName,
            dpiCity: intake.case.death.deadPerson.dpCity,
            dpiCountry: intake.case.death.deadPerson.dpCountry,
            dpiMaidenName: intake.case.death.deadPerson.dpMaidenName,
            dpiDateOfBirth: intake.case.death.deadPerson.dpDateOfBirth
              ? this.dateService.getLocalISODateFormat(intake.case.death.deadPerson.dpDateOfBirth)
              : null,
            dpiBSN: intake.case.death.deadPerson.dpBsn,
            dpiLength: intake.case.death.deadPerson.dpLength != null ? intake.case.death.deadPerson.dpLength : null,
            dpiWeight: intake.case.death.deadPerson.dpWeight != null ? intake.case.death.deadPerson.dpWeight : null,
            dpiBirthPlace: intake.case.death.deadPerson.dpBirthPlace,
            dpiProfession: intake.case.death.deadPerson.dpProfession,
            dpiReligion: intake.case.death.deadPerson.dpReligion,
            dpiWeddingDate: intake.case.death.deadPerson.dpWeddingDate
            ? this.dateService.getLocalISODateFormat(intake.case.death.deadPerson.dpWeddingDate)
            : null,
            dpiPlaceOfMarriae:
              intake.case.death.deadPerson.dpPlaceOfMarriage,
            dpiIsFatherAlive: intake.case.death.deadPerson.dpIsFatherAlive,
            dpiFatherName: intake.case.death.deadPerson.dpFatherName,
            dpiIsMotherAlive: intake.case.death.deadPerson.dpIsMotherAlive,
            dpiMotherName: intake.case.death.deadPerson.dpMotherName,
            dpiWithPassport:
              (intake.case.death.deadPerson.dpWithPassport != null)
                ? intake.case.death.deadPerson.dpWithPassport
                : null,
            dpiHasPassportCopy:
              intake.case.death.deadPerson.dpHasPassportCopy,
            isJewelryTakenOff:
              intake.case.death.deadPerson.dpIsJewelryTakenOff,
            dpiHasLuggage: intake.case.death.deadPerson.dpHasLuggage,
            dpiLuggageInformation:
              intake.case.death.deadPerson.dpMluggageInformation,
            dpiSignature: intake.case.death.deadPerson.dpSignature,
            kindOfFuneral:
              (intake.case.death.deadPerson.dpFuneralType != null)
                ? intake.case.death.deadPerson.dpFuneralType
                : null,
            dsiFirstName: intake.case.death.deadPerson.dpSpouseFirstName,
            dsiLastName: intake.case.death.deadPerson.dpSpouseLastName,
            dsiDateOfBirth: intake.case.death.deadPerson.dpSpouseDateOfBirth
            ? this.dateService.getLocalISODateFormat(intake.case.death.deadPerson.dpSpouseDateOfBirth)
            : null,
            dsiBirthPlace:
              intake.case.death.deadPerson.dpSpousePlaceOfBirth,
            cpiFirstName:
              intake.case.death.deadPerson.dpContactPersonFirstName,
            cpiLastName:
              intake.case.death.deadPerson.dpContactPersonLastName,
            cpiPhoneNumber:
              intake.case.death.deadPerson.dpContactPersonPhoneNumber &&
                intake.case.death.deadPerson.dpContactPersonPhoneNumber.toString()
                ? intake.case.death.deadPerson.dpContactPersonPhoneNumber.toString()
                : null,
            cpiSpeaksEnglish:
              intake.case.death.deadPerson.dpContactPersonSpeaksEnglish,
          },
        diagnoseDetail:!intake.case.diagnoseDetail
          ? null
          : {
            diagnose: intake.case.diagnoseDetail.diagnose,
            midOfficeDiagnoseTypeId: intake.case.diagnoseDetail.midOfficeDiagnoseTypeId != null ? intake.case.diagnoseDetail.midOfficeDiagnoseTypeId : null,
            icdDiagnoseId: intake.case.diagnoseDetail.cdICDDiagnose != null ? intake.case.diagnoseDetail.cdICDDiagnose : null,
            manualIcdDiagnose: intake.case.diagnoseDetail.manualIcdDiagnose,
            icdCode: intake.case.diagnoseDetail.cdICDCode,
            diagnosis: intake.case.diagnoseDetail.diagnosis,
            medicalInformation: intake.case.diagnoseDetail.medicalInformation,
            medicalHistory: intake.case.diagnoseDetail.medicalHistory,
            nameOfGeneralPractioner:
              intake.case.diagnoseDetail.nameOfGeneralPractioner,
            cityOfGeneralPractitioner:
              intake.case.diagnoseDetail.cityOfGeneralPractitioner,
            nameSpecialist: intake.case.diagnoseDetail.nameSpecialist,
            hospitalinNL: intake.case.diagnoseDetail.hospitalinNL,
            phoneNumber: intake.case.diagnoseDetail.phoneNumber ? intake.case.diagnoseDetail.phoneNumber.toString() : null,
            hasPermission: intake.case.diagnoseDetail.hasPermission,
            cdPhonenumberofSpecialist: intake.case.diagnoseDetail.cdPhonenumberofSpecialist,
            cdNameofSpecialist: intake.case.diagnoseDetail.cdNameofSpecialist,
            cdPhonenumberForeignSpecialist: intake.case.diagnoseDetail.cdPhonenumberForeignSpecialist,
            hospital: intake.case.diagnoseDetail.hospital,
            mediacalComments: intake.case.diagnoseDetail.mediacalComments,
            hasMedicalReport: intake.case.diagnoseDetail.hasMedicalReport,
            hasFitFlyDocument: intake.case.diagnoseDetail.hasFitFlyDocument,
            canSendDocuments: intake.case.diagnoseDetail.cdCanSendDocuments,
            extraInformationComments:
              intake.case.diagnoseDetail.extraInformationComments,
            creationDate : intake.case.diagnoseDetail.creationDate
          },
        generalDetail:!intake.case.general
          ? null
          : {
            value1: intake.case.general.value1,
            value2: intake.case.general.value2,
            value3: intake.case.general.value3,
            value4: intake.case.general.value4,
          },
        callbackDetail:!intake.case.callBack
          ? null
          : {
            reason: intake.case.callBack.reason,
            situation: intake.case.callBack.situation,
            gender: intake.case.callBack.gender,
            lastName: intake.case.callBack.lastName,
            firstName: intake.case.callBack.firstName,
            dateOfBirth: intake.case.callBack.dateOfBirth
              ? intake.case.callBack.dateOfBirth
              : null,
            relationId: intake.case.callBack.relationId != null ? intake.case.callBack.relationId : null,
            deathDate: intake.case.callBack.deathDate
              ? intake.case.callBack.deathDate
              : null,
            funeralDate: intake.case.callBack.funeralDate
              ? intake.case.callBack.funeralDate
              : null,
            hospitalizationDate: intake.case.callBack.hospitalizationDate
              ? intake.case.callBack.hospitalizationDate
              : null,
            comment: intake.case.callBack.comment,
            residence: intake.case.callBack.residence,
            postalCode: intake.case.callBack.postalCode,
            address: intake.case.callBack.address,
            houseNumber: intake.case.callBack.houseNumber,
            city: intake.case.callBack.city,
            countryId: intake.case.callBack.country ? intake.case.callBack.country.id : null,
            numberOfFellowTravellers: intake.case.callBack.numberOfFellowTravellers ? intake.case.callBack.numberOfFellowTravellers.toString() : null,
            from: intake.case.callBack.from,
            to: intake.case.callBack.to,
            journeyType: intake.case.callBack.journeyType,
            returnDate: intake.case.callBack.returnDate
              ? intake.case.callBack.returnDate
              : null,
            luggage: intake.case.callBack.luggage,
            wheelchair: intake.case.callBack.wheelchair,
            bookingNumber: intake.case.callBack.bookingNumber,
            airline: intake.case.callBack.airline,
            isAirLineBooked: intake.case.callBack.isAirLineBooked
              ? intake.case.callBack.isAirLineBooked
              : false,
          },
      },
      locations: [],
      travel: intake.travel == null
        ? null
        : {
          purpose: intake.travel.tdPurpose,
          type: intake.travel.tdType,
          carrier: intake.travel.tdCarrier,
          tourOperator: intake.travel.tdTourOperator,
          group: intake.travel.tdGroup,
          adultsNumber: Number(intake.travel.tdAdultsNumber),
          childrenNumber: Number(intake.travel.tdChildrenNumber),
          from: intake.travel.tdFrom,
          to: intake.travel.tdTo,
          startDate: this.dateService.getLocalISODateFormat(intake.travel.tdStartDate),
          goingFlightNumber: intake.travel.tdGoingFlightNumber,
          isReturnBooked: intake.travel.tdIsReturnBooked,
          returnDate: this.dateService.getLocalISODateFormat(intake.travel.tdReturnDate),
          returnFlightNumber: intake.travel.tdGoingFlightNumber,
          bookingNumber: intake.travel.tdBookingNumber,
          isTicketChangeable: intake.travel.tdIsTicketChangeable,
          bookingAgency: intake.travel.tdBookingAgency,
          bookingAgencyPhoneNumber:
            intake.travel.tdBookingAgencyPhoneNumber &&
              intake.travel.tdBookingAgencyPhoneNumber.toString()
              ? intake.travel.tdBookingAgencyPhoneNumber.toString()
              : null,
          travelPlan: intake.travel.tdTravelPlan
        },
      parties: [],
      helpPlans: [],
      roles: intake.roles
    };
  }

fillIntakeDataUpdate(intake: IntakeDataModel) {
return {
  userName: this.authenticationService.currentUserValue.name,
  userEmail: this.authenticationService.currentUserValue.unique_name,
  dossierId: intake.dossierId,
  dossierNumber: intake.policy.dossierNbr,
  intakeDuration: intake.intakeDuration,
  comments: intake.summary.comment,
  agreements: intake.summary.agreement,
  coverage: intake.summary.coverage,
  dossierStatus: intake.dossierStatus,
  linkedDossiers: intake.linkedDossiers,
  insuree: {
    bsn: intake.insuree.ipaBsnCitizenServiceNumber,
    initials: intake.insuree.ipaInitials,
    firstName: intake.insuree.ipaFirstName,
    lastName: intake.insuree.ipaLastName,
    maidenName: intake.insuree.ipaMaidenName,
    streetName: intake.insuree.ipaStreetName,
    houseNumber: intake.insuree.ipaHouseNumber,
    houseNumberAddition: intake.insuree.ipaHouseNumberAddition,
    postalCode: intake.insuree.ipaPostalCode,
    city: intake.insuree.ipaCity,
    countryId: intake.insuree.country.id,
    phoneNumber: intake.insuree.ipaPhoneNumber ? intake.insuree.ipaPhoneNumber.toString() : null,
    phoneNumber2:
      intake.insuree.ipaPhoneNumber2 ? intake.insuree.ipaPhoneNumber2.toString() : null,
    email: intake.insuree.ipaEmail,
    dateOfBirth: this.dateService.getLocalISODateFormat(intake.insuree.ipaDateOfBirth),
    gender: intake.insuree.ipaPartyGender ? intake.insuree.ipaPartyGender.toString() : null,
    remarks: intake.insuree.ipaRemarks,
    contactInitiationId: intake.insuree.ipaContactInitiation,
    contactWithId: intake.insuree.ipaContactWith,
    contactInitiationPhone: intake.insuree.ipaContactTelephone,
    contactEmail: intake.insuree.ipaContactEmail,
    contactComment: intake.insuree.ipaContactComment,
    sharePrivateInformation : intake.insuree.ipaSharePrivateInformation,
    contactPersons: [],
  },
  policy: {
    caseTypeId: intake.policy.cause.ctyId,
    clientId: intake.policy.client ? intake.policy.client.id : null,
    isOwnCost: intake.policy.isNoPolicycheck,
    accidentLocation: intake.policy.location,
    countryId: intake.policy.country.id,
    reason: intake.policy.reason,
    calamityId :intake.policy.selectedCalamities? intake.policy.selectedCalamities.calId:null,
    incidentDate: this.dateService.getLocalISODateFormat(intake.policy.incidentDate),
    iagPartnerCaseNumber: intake.policy.iagPartnerCaseNumber,
    iagPartnerId: intake.policy.iagCorePartner ? intake.policy.iagCorePartner.id : null,
    nedherlandAlaId: intake.policy.nedherlandAla ? intake.policy.nedherlandAla.id : null,
    travelInsurancePolicies: [],
    healthInsurancePolicies: [],
    noInsurancePolicies: []
  },
  caseDetail:intake.case == null?null: {
    deathDetail: intake.case.death == null
      ? null
      : {
        dateOfDeath: intake.case.death.dthDateOfDeath
        ? this.dateService.getLocalISODateFormat(intake.case.death.dthDateOfDeath)
        : null,
        causeOfDeath: (intake.case.death.dthCauseOfDeath != null)
          ? intake.case.death.dthCauseOfDeath
          : null,
        isAutopsy:
          (intake.case.death.dthIsAutopy != null)
            ? intake.case.death.dthIsAutopy
            : null,
        isPoliceInvolved:
          (intake.case.death.dthIsPoliceInvolved != null)
            ? intake.case.death.dthIsPoliceInvolved
            : null,
        description: intake.case.death.dthDescription,
        dutchCoroner: intake.case.death.dutchCoroner ? this.mapCoroners(intake.case.death.dutchCoroner) : null,
        foreignCoroner: intake.case.death.foreignCorner ? this.mapCoroners(
          intake.case.death.foreignCorner
        ) : null,
        dpiFirstName: intake.case.death.deadPerson.dpFirstName,
        dpiLastName: intake.case.death.deadPerson.dpLastName,
        dpiPostalCode: intake.case.death.deadPerson.dpPostalCode,
        dpiHouseNumber: intake.case.death.deadPerson.dpHouseNumber,
        dpiHouseNumberAddition: intake.case.death.deadPerson.dpHouseNumberAddition,
        dpiStreetName: intake.case.death.deadPerson.dpStreetName,
        dpiCity: intake.case.death.deadPerson.dpCity,
        dpiCountry: intake.case.death.deadPerson.dpCountry,
        dpiMaidenName: intake.case.death.deadPerson.dpMaidenName,
        dpiDateOfBirth: intake.case.death.deadPerson.dpDateOfBirth
          ? this.dateService.getLocalISODateFormat(intake.case.death.deadPerson.dpDateOfBirth)
          : null,
        dpiBSN: intake.case.death.deadPerson.dpBsn,
        dpiLength: intake.case.death.deadPerson.dpLength != null ? intake.case.death.deadPerson.dpLength : null,
        dpiWeight: intake.case.death.deadPerson.dpWeight != null ? intake.case.death.deadPerson.dpWeight : null,
        dpiBirthPlace: intake.case.death.deadPerson.dpBirthPlace,
        dpiProfession: intake.case.death.deadPerson.dpProfession,
        dpiReligion: intake.case.death.deadPerson.dpReligion,
        dpiWeddingDate: intake.case.death.deadPerson.dpWeddingDate
        ? this.dateService.getLocalISODateFormat(intake.case.death.deadPerson.dpWeddingDate) 
        : null,
        dpiPlaceOfMarriae:
          intake.case.death.deadPerson.dpPlaceOfMarriage,
        dpiIsFatherAlive: intake.case.death.deadPerson.dpIsFatherAlive,
        dpiFatherName: intake.case.death.deadPerson.dpFatherName,
        dpiIsMotherAlive: intake.case.death.deadPerson.dpIsMotherAlive,
        dpiMotherName: intake.case.death.deadPerson.dpMotherName,
        dpiWithPassport:
          (intake.case.death.deadPerson.dpWithPassport != null)
            ? intake.case.death.deadPerson.dpWithPassport
            : null,
        dpiHasPassportCopy:
          intake.case.death.deadPerson.dpHasPassportCopy,
        isJewelryTakenOff:
          intake.case.death.deadPerson.dpIsJewelryTakenOff,
        dpiHasLuggage: intake.case.death.deadPerson.dpHasLuggage,
        dpiLuggageInformation:
          intake.case.death.deadPerson.dpMluggageInformation,
        dpiSignature: intake.case.death.deadPerson.dpSignature,
        kindOfFuneral:
          (intake.case.death.deadPerson.dpFuneralType != null)
            ? intake.case.death.deadPerson.dpFuneralType
            : null,
        dsiFirstName: intake.case.death.deadPerson.dpSpouseFirstName,
        dsiLastName: intake.case.death.deadPerson.dpSpouseLastName,
        dsiDateOfBirth: intake.case.death.deadPerson.dpSpouseDateOfBirth
        ? this.dateService.getLocalISODateFormat(intake.case.death.deadPerson.dpSpouseDateOfBirth)
        : null,
        dsiBirthPlace:
          intake.case.death.deadPerson.dpSpousePlaceOfBirth,
        cpiFirstName:
          intake.case.death.deadPerson.dpContactPersonFirstName,
        cpiLastName:
          intake.case.death.deadPerson.dpContactPersonLastName,
        cpiPhoneNumber:
          intake.case.death.deadPerson.dpContactPersonPhoneNumber &&
            intake.case.death.deadPerson.dpContactPersonPhoneNumber.toString()
            ? intake.case.death.deadPerson.dpContactPersonPhoneNumber.toString()
            : null,
        cpiSpeaksEnglish:
          intake.case.death.deadPerson.dpContactPersonSpeaksEnglish,
      },
    diagnoseDetail:!intake.case.diagnoseDetail
      ? null
      : {
        diagnose: intake.case.diagnoseDetail.diagnose,
        midOfficeDiagnoseTypeId: intake.case.diagnoseDetail.midOfficeDiagnoseTypeId != null ? intake.case.diagnoseDetail.midOfficeDiagnoseTypeId : null,
        icdDiagnoseId: intake.case.diagnoseDetail.cdICDDiagnose != null ? intake.case.diagnoseDetail.cdICDDiagnose : null,
        manualIcdDiagnose: intake.case.diagnoseDetail.manualIcdDiagnose,
        icdCode: intake.case.diagnoseDetail.cdICDCode,
        diagnosis: intake.case.diagnoseDetail.diagnosis,
        medicalInformation: intake.case.diagnoseDetail.medicalInformation,
        medicalHistory: intake.case.diagnoseDetail.medicalHistory,
        nameOfGeneralPractioner:
          intake.case.diagnoseDetail.nameOfGeneralPractioner,
        cityOfGeneralPractitioner:
          intake.case.diagnoseDetail.cityOfGeneralPractitioner,
        nameSpecialist: intake.case.diagnoseDetail.nameSpecialist,
        hospitalinNL: intake.case.diagnoseDetail.hospitalinNL,
        phoneNumber: intake.case.diagnoseDetail.phoneNumber ? intake.case.diagnoseDetail.phoneNumber.toString() : null,
        hasPermission: intake.case.diagnoseDetail.hasPermission,
        cdPhonenumberofSpecialist: intake.case.diagnoseDetail.cdPhonenumberofSpecialist,
        cdNameofSpecialist: intake.case.diagnoseDetail.cdNameofSpecialist,
        cdPhonenumberForeignSpecialist: intake.case.diagnoseDetail.cdPhonenumberForeignSpecialist,
        hospital: intake.case.diagnoseDetail.hospital,
        mediacalComments: intake.case.diagnoseDetail.mediacalComments,
        hasMedicalReport: intake.case.diagnoseDetail.hasMedicalReport,
        hasFitFlyDocument: intake.case.diagnoseDetail.hasFitFlyDocument,
        canSendDocuments: intake.case.diagnoseDetail.cdCanSendDocuments,
        extraInformationComments:
          intake.case.diagnoseDetail.extraInformationComments,
      },
    generalDetail:!intake.case.general
      ? null
      : {
        value1: intake.case.general.value1,
        value2: intake.case.general.value2,
        value3: intake.case.general.value3,
        value4: intake.case.general.value4,
      },
    callbackDetail:!intake.case.callBack
      ? null
      : {
        reason: intake.case.callBack.reason,
        situation: intake.case.callBack.situation,
        gender: intake.case.callBack.gender,
        lastName: intake.case.callBack.lastName,
        firstName: intake.case.callBack.firstName,
        dateOfBirth: intake.case.callBack.dateOfBirth
          ? intake.case.callBack.dateOfBirth
          : null,
        relationId: intake.case.callBack.relationId != null ? intake.case.callBack.relationId : null,
        deathDate: intake.case.callBack.deathDate
          ? intake.case.callBack.deathDate
          : null,
        funeralDate: intake.case.callBack.funeralDate
          ? intake.case.callBack.funeralDate
          : null,
        hospitalizationDate: intake.case.callBack.hospitalizationDate
          ? intake.case.callBack.hospitalizationDate
          : null,
        comment: intake.case.callBack.comment,
        residence: intake.case.callBack.residence,
        postalCode: intake.case.callBack.postalCode,
        address: intake.case.callBack.address,
        houseNumber: intake.case.callBack.houseNumber,
        city: intake.case.callBack.city,
        countryId: intake.case.callBack.country ? intake.case.callBack.country.id : null,
        numberOfFellowTravellers: intake.case.callBack.numberOfFellowTravellers ? intake.case.callBack.numberOfFellowTravellers.toString() : null,
        from: intake.case.callBack.from,
        to: intake.case.callBack.to,
        journeyType: intake.case.callBack.journeyType,
        returnDate: intake.case.callBack.returnDate
          ? intake.case.callBack.returnDate
          : null,
        luggage: intake.case.callBack.luggage,
        wheelchair: intake.case.callBack.wheelchair,
        bookingNumber: intake.case.callBack.bookingNumber,
        airline: intake.case.callBack.airline,
        isAirLineBooked: intake.case.callBack.isAirLineBooked
          ? intake.case.callBack.isAirLineBooked
          : false,
      },
  },
  locations: [],
  travel: intake.travel == null
    ? null
    : {
      purpose: intake.travel.tdPurpose,
      type: intake.travel.tdType,
      carrier: intake.travel.tdCarrier,
      tourOperator: intake.travel.tdTourOperator,
      group: intake.travel.tdGroup,
      adultsNumber: intake.travel.tdAdultsNumber,
      childrenNumber: intake.travel.tdChildrenNumber,
      from: intake.travel.tdFrom,
      to: intake.travel.tdTo,
      startDate: this.dateService.getLocalISODateFormat(intake.travel.tdStartDate),
      goingFlightNumber: intake.travel.tdGoingFlightNumber,
      isReturnBooked: intake.travel.tdIsReturnBooked,
      returnDate: this.dateService.getLocalISODateFormat(intake.travel.tdReturnDate),
      returnFlightNumber: intake.travel.tdReturnFlightNumber,
      bookingNumber: intake.travel.tdBookingNumber,
      isTicketChangeable: intake.travel.tdIsTicketChangeable,
      bookingAgency: intake.travel.tdBookingAgency,
      bookingAgencyPhoneNumber:
        intake.travel.tdBookingAgencyPhoneNumber &&
          intake.travel.tdBookingAgencyPhoneNumber.toString()
          ? intake.travel.tdBookingAgencyPhoneNumber.toString()
          : null,
      travelPlan: intake.travel.tdTravelPlan
    },
    rehospitalisation: {
      type:intake.rehospitalisation ? intake.rehospitalisation.type : null,
      supplierId: intake.rehospitalisation.supplier,
      admissionDate: intake.rehospitalisation.admissionDate,
      department: intake.rehospitalisation.department,
      reportAt: intake.rehospitalisation.reportAt,
      comment: intake.rehospitalisation.comment,
      consentingDoctorContactPersonName: intake.rehospitalisation.consentingDoctor_ContactPersonName,
      consentingDoctorContactPersonFunction: intake.rehospitalisation.consentingDoctor_ContactPersonFunction,
      consentingDoctorContactPersonPhoneNumber: intake.rehospitalisation.consentingDoctor_ContactPersonPhoneNumber
    },
    adl: intake.adl == null || intake.adl == undefined ? null : {
      length: intake.adl.length,
      weight: intake.adl.weight,
      adlMobility: intake.adl.adlMobility,
      heartLungProblems: intake.adl.heartLungProblems,
      repatriationQuestion: intake.adl.repatriationQuestion,
      cast: intake.adl.cast,
      covid: intake.adl.covid,
      adlOtherActivities: intake.adl.adlOtherActivities,
      homeSituation: intake.adl.homeSituation
    },
  parties: [],
  helpPlans: [],
  roles : intake.roles,
};
}

dataToAPIPost(intake: IntakeDataModel) {
let intakeDataResult = this.fillIntakeDataPost(intake);
intakeDataResult = this.fillIntakeLists(intake, intakeDataResult);
return intakeDataResult;
}

dataToAPIUpdate(intake: IntakeDataModel) {
let intakeDataResult = this.fillIntakeDataUpdate(intake);
intakeDataResult = this.fillIntakeLists(intake, intakeDataResult);
return intakeDataResult;
}


  dataToUpdateHelpPlan(helpPlan:HelpPlanDetailsModel){
     if (helpPlan != undefined && helpPlan != null) {
       let mappedHelpPlan = this.mapUpdateHelpPlans(helpPlan);
       return mappedHelpPlan;
     }
  }
  mapRelatedActionProperties(dossierActionNotes,dossierNoteModel) {            
    const actionNote =  dossierActionNotes[0];
    dossierNoteModel.actionType =this.sharedService.hasProperty(actionNote, "donDossierAction.doaActionType.atLongName") ?
    actionNote.donDossierAction.doaActionType.atLongName : null;

    dossierNoteModel.actionStatus = this.sharedService.hasProperty(actionNote, "donDossierAction.doaStatus.dasLongName") ?
    actionNote.donDossierAction.doaStatus.dasLongName : null;
  }
}

